{
  "about.blocks": "Moderoidut palvelimet",
  "about.contact": "Yhteydenotto:",
  "about.default_locale": "Oletus",
  "about.disclaimer": "Mastodon on vapaa avoimen lähdekoodin ohjelmisto ja Mastodon GmbH:n tavaramerkki.",
  "about.domain_blocks.no_reason_available": "Syy ei ole tiedossa",
  "about.domain_blocks.preamble": "Mastodonin avulla voi yleensä tarkastella minkä tahansa fediversumiin kuuluvan palvelimen sisältöä ja olla yhteyksissä eri palvelinten käyttäjien kanssa. Nämä poikkeukset koskevat yksin tätä palvelinta.",
  "about.domain_blocks.silenced.explanation": "Et yleensä näe tämän palvelimen profiileja ja sisältöä, jollet erityisesti etsi juuri sitä tai liity siihen seuraamalla.",
  "about.domain_blocks.silenced.title": "Rajoitettu",
  "about.domain_blocks.suspended.explanation": "Mitään tämän palvelimen tietoja ei käsitellä, tallenneta eikä vaihdeta, mikä tekee vuorovaikutuksesta ja viestinnästä sen käyttäjien kanssa mahdotonta.",
  "about.domain_blocks.suspended.title": "Jäädytetty",
  "about.language_label": "Kieli",
  "about.not_available": "Näitä tietoja ei ole julkaistu tällä palvelimella.",
  "about.powered_by": "Hajautetun sosiaalisen median tarjoaa {mastodon}",
  "about.rules": "Palvelimen säännöt",
  "account.account_note_header": "Henkilökohtainen muistiinpano",
  "account.activity": "Toiminta",
  "account.add_note": "Lisää henkilökohtainen muistiinpano",
  "account.add_or_remove_from_list": "Lisää tai poista listoilta",
  "account.badges.admin": "Ylläpitäjä",
  "account.badges.blocked": "Estetty",
  "account.badges.bot": "Botti",
  "account.badges.domain_blocked": "Estetty verkkotunnus",
  "account.badges.group": "Ryhmä",
  "account.badges.muted": "Mykistetty",
  "account.badges.muted_until": "Mykistetty {until} asti",
  "account.block": "Estä @{name}",
  "account.block_domain": "Estä verkkotunnus {domain}",
  "account.block_short": "Estä",
  "account.blocked": "Estetty",
  "account.cancel_follow_request": "Peruuta seurantapyyntö",
  "account.copy": "Kopioi linkki profiiliin",
  "account.direct": "Mainitse @{name} yksityisesti",
  "account.disable_notifications": "Lopeta ilmoittamasta minulle, kun @{name} julkaisee",
  "account.edit_note": "Muokkaa henkilökohtaista muistiinpanoa",
  "account.edit_profile": "Muokkaa profiilia",
  "account.edit_profile_short": "Muokkaa",
  "account.enable_notifications": "Ilmoita minulle, kun @{name} julkaisee",
  "account.endorse": "Esittele profiilissa",
  "account.familiar_followers_many": "Seuraajina {name1}, {name2} ja {othersCount, plural, one {1 muu, jonka tunnet} other {# muuta, jotka tunnet}}",
  "account.familiar_followers_one": "Seuraajana {name1}",
  "account.familiar_followers_two": "Seuraajina {name1} ja {name2}",
  "account.featured": "Esittelyssä",
  "account.featured.accounts": "Profiilit",
  "account.featured.collections": "Kokoelmat",
  "account.featured.new_collection": "Uusi kokoelma",
  "account.field_overflow": "Näytä koko sisältö",
  "account.filters.all": "Kaikki toiminta",
  "account.filters.boosts_toggle": "Näytä tehostukset",
  "account.filters.posts_boosts": "Julkaisut ja tehostukset",
  "account.filters.posts_only": "Julkaisut",
  "account.filters.posts_replies": "Julkaisut ja vastaukset",
  "account.filters.replies_toggle": "Näytä vastaukset",
  "account.follow": "Seuraa",
  "account.follow_back": "Seuraa takaisin",
  "account.follow_back_short": "Seuraa takaisin",
  "account.follow_request": "Pyydä lupaa seurata",
  "account.follow_request_cancel": "Peruuta pyyntö",
  "account.follow_request_cancel_short": "Peruuta",
  "account.follow_request_short": "Pyyntö",
  "account.followers": "Seuraajat",
  "account.followers.empty": "Kukaan ei seuraa tätä käyttäjää vielä.",
  "account.followers_counter": "{count, plural, one {{counter} seuraaja} other {{counter} seuraajaa}}",
  "account.followers_you_know_counter": "{count, plural, one {{counter} tuntemasi} other {{counter} tuntemaasi}}",
  "account.following": "Seurattavat",
  "account.following_counter": "{count, plural, one {{counter} seurattava} other {{counter} seurattavaa}}",
  "account.follows.empty": "Tämä käyttäjä ei vielä seuraa ketään.",
  "account.follows_you": "Seuraa sinua",
  "account.go_to_profile": "Siirry profiiliin",
  "account.hame.invalid_handle": "Käyttäjätunnus ei saatavilla",
  "account.hide_reblogs": "Piilota käyttäjän @{name} tehostukset",
  "account.in_memoriam": "Muistoissamme.",
  "account.join_modal.day": "päivä",
  "account.join_modal.me": "Liityit palvelimelle {server}",
  "account.join_modal.me_anniversary": "Hyvää fediversumin vuosipäivää! Liityit palvelimelle {server}",
  "account.join_modal.me_today": "On ensimmäinen päiväsi palvelimella {server}!",
  "account.join_modal.other": "{name} liittyi palvelimelle {server}",
  "account.join_modal.other_today": "On käyttäjän {name} ensimmäinen päivä palvelimella {server}!",
  "account.join_modal.share.celebrate": "Jaa juhlajulkaisu",
  "account.join_modal.share.intro": "Jaa esittelyjulkaisu",
  "account.join_modal.share.welcome": "Jaa tervetulojulkaisu",
  "account.join_modal.years": "{number, plural, one {vuosi} other {vuotta}}",
  "account.joined_short": "Liittynyt",
  "account.languages": "Vaihda tilattuja kieliä",
  "account.last_active": "Viimeksi aktiivisena",
  "account.link_verified_on": "Linkin omistus tarkistettiin {date}",
  "account.locked_info": "Tilin yksityisyystilaksi on määritetty lukittu. Tilin omistaja arvioi erikseen, kuka voi seurata häntä.",
  "account.media": "Media",
  "account.mention": "Mainitse @{name}",
  "account.menu.add_to_collection": "Lisää kokoelmaan…",
  "account.menu.add_to_list": "Lisää listaan…",
  "account.menu.block": "Estä tili",
  "account.menu.block_domain": "Estä {domain}",
  "account.menu.copied": "Tlin linkki kopioitu leikepöydälle",
  "account.menu.copy": "Kopioi linkki",
  "account.menu.direct": "Mainitse yksityisesti",
  "account.menu.hide_reblogs": "Piilota tehostukset aikajanalta",
  "account.menu.mention": "Mainitse",
  "account.menu.mute": "Mykistä tili",
  "account.menu.note.description": "Näkyvät vain sinulle",
  "account.menu.open_original_page": "Näytä palvelimella {domain}",
  "account.menu.open_original_page_no_domain": "Näytä alkuperäisellä palvelimella",
  "account.menu.remove_follower": "Poista seuraaja",
  "account.menu.report": "Raportoi tili",
  "account.menu.share": "Jaa…",
  "account.menu.show_reblogs": "Näytä tehostukset aikajanalla",
  "account.menu.unblock": "Kumoa tilin esto",
  "account.menu.unblock_domain": "Kumoa palvelimen {domain} esto",
  "account.menu.unmute": "Kumoa tilin mykistys",
  "account.moved_to": "{name} on ilmoittanut uudeksi tilikseen",
  "account.mute": "Mykistä @{name}",
  "account.mute_notifications_short": "Mykistä ilmoitukset",
  "account.mute_short": "Mykistä",
  "account.muted": "Mykistetty",
  "account.mutual": "Seuraatte toisianne",
  "account.name.copy": "Kopioi käyttäjätunnus",
  "account.name.help.domain": "{domain} on palvelin, jolla käyttäjän profiili ja julkaisut sijaitsevat.",
  "account.name.help.domain_self": "{domain} on palvelin, jolla profiilisi ja julkaisusi sijaitsevat.",
  "account.name.help.footer": "Aivan kuten voit lähettää sähköpostia eri sähköpostipalveluntarjoajien avulla, voit olla yhteydessä muihin Mastodon-palvelimiin ja kehen tahansa, joka käyttää fediversumin sovelluksia.",
  "account.name.help.header": "Käyttäjätunnus on kuin sähköpostiosoite",
  "account.name.help.invalid_explanation": "Näin voi tapahtua, kun käyttäjä vaihtaa käyttäjätunnustaan, ja ongelma on yleensä väliaikainen. Jos tämä jatkuu, se voi johtua palvelimesta, joka ei ole saatavilla, tai virheellisestä määrityksestä toisella palvelimella.",
  "account.name.help.invalid_header": "Tämän käyttäjän käyttäjätunnusta päivitetään",
  "account.name.help.username": "{username} on tämän tilin käyttäjänimi omalla palvelimellaan. Jollakin toisen palvelimen tilillä voi olla sama käyttäjänimi.",
  "account.name.help.username_self": "{username} on käyttäjänimesi tällä palvelimella. Jollakin toisen palvelimen tilillä voi olla sama käyttäjänimi.",
  "account.name_info": "Mitä tämä tarkoittaa?",
  "account.no_bio": "Kuvausta ei ole annettu.",
  "account.node_modal.callout": "Henkilökohtaiset muistiinpanot näkyvät vain sinulle.",
  "account.node_modal.edit_title": "Muokkaa henkilökohtaista muistiinpanoa",
  "account.node_modal.error_unknown": "Muistiinpanoa ei voitu tallentaa",
  "account.node_modal.field_label": "Henkilökohtainen muistiinpano",
  "account.node_modal.save": "Tallenna",
  "account.node_modal.title": "Lisää henkilökohtainen muistiinpano",
  "account.note.edit_button": "Muokkaa",
  "account.note.title": "Henkilökohtainen muistiinpano (näkyy vain sinulle)",
  "account.open_original_page": "Avaa alkuperäinen sivu",
  "account.pending": "Odottava",
  "account.posts": "Julkaisut",
  "account.remove_from_followers": "Poista {name} seuraajista",
  "account.report": "Raportoi @{name}",
  "account.requested_follow": "{name} on pyytänyt lupaa seurata sinua",
  "account.share": "Jaa käyttäjän @{name} profiili",
  "account.show_reblogs": "Näytä käyttäjän @{name} tehostukset",
  "account.statuses_counter": "{count, plural, one {{counter} julkaisu} other {{counter} julkaisua}}",
  "account.timeline.pinned": "Kiinnitetty",
  "account.timeline.pinned.view_all": "Näytä kaikki kiinnitetyt julkaisut",
  "account.unblock": "Kumoa käyttäjän @{name} esto",
  "account.unblock_domain": "Kumoa verkkotunnuksen {domain} esto",
  "account.unblock_domain_short": "Kumoa esto",
  "account.unblock_short": "Kumoa esto",
  "account.unendorse": "Kumoa profiilissa esittely",
  "account.unfollow": "Älä seuraa",
  "account.unmute": "Kumoa käyttäjän @{name} mykistys",
  "account.unmute_notifications_short": "Kumoa ilmoitusten mykistys",
  "account.unmute_short": "Kumoa mykistys",
  "account_edit.advanced_settings.bot_hint": "Ilmaise muille, että tili suorittaa enimmäkseen automaattisia toimia eikä sitä välttämättä valvota",
  "account_edit.advanced_settings.bot_label": "Bottitili",
  "account_edit.advanced_settings.title": "Edistyneet asetukset",
  "account_edit.bio.add_label": "Lisää elämäkerta",
  "account_edit.bio.edit_label": "Muokkaa elämäkertaa",
  "account_edit.bio.placeholder": "Lisää lyhyt esittely, joka auttaa muita tunnistamaan sinut.",
  "account_edit.bio.title": "Elämäkerta",
  "account_edit.bio_modal.add_title": "Lisää elämäkerta",
  "account_edit.bio_modal.edit_title": "Muokkaa elämäkertaa",
  "account_edit.column_button": "Valmis",
  "account_edit.column_title": "Muokkaa profiilia",
  "account_edit.custom_fields.add_label": "Lisää kenttä",
  "account_edit.custom_fields.edit_label": "Muokkaa kenttää",
  "account_edit.custom_fields.placeholder": "Lisää pronominisi, ulkoisia linkkejä tai mitä tahansa muuta, jonka haluat jakaa.",
  "account_edit.custom_fields.reorder_button": "Järjestele kenttiä",
  "account_edit.custom_fields.tip_content": "Voit helposti lisätä Mastodon-tilisi uskottavuutta vahvistamalla mihin tahansa omistamaasi verkkosivustoon ohjaavat linkit.",
  "account_edit.custom_fields.tip_title": "Vinkki: Vahvistettujen linkkien lisääminen",
  "account_edit.custom_fields.title": "Mukautetut kentät",
  "account_edit.custom_fields.verified_hint": "Miten lisään vahvistetun linkin?",
  "account_edit.display_name.add_label": "Lisää näyttönimi",
  "account_edit.display_name.edit_label": "Muokkaa näyttönimeä",
  "account_edit.display_name.placeholder": "Näyttönimesi on nimi, joka näkyy profiilissasi ja aikajanoilla.",
  "account_edit.display_name.title": "Näyttönimi",
  "account_edit.featured_hashtags.edit_label": "Lisää aihetunnisteita",
  "account_edit.featured_hashtags.placeholder": "Auta muita tunnistamaan suosikkiaiheesi ja saamaan nopea pääsy niihin.",
  "account_edit.featured_hashtags.title": "Esiteltävät aihetunnisteet",
  "account_edit.field_actions.delete": "Poista kenttä",
  "account_edit.field_actions.edit": "Muokkaa kenttää",
  "account_edit.field_delete_modal.confirm": "Haluatko varmasti poistaa tämän mukautetun kentän? Tätä toimea ei voi peruuttaa.",
  "account_edit.field_delete_modal.delete_button": "Poista",
  "account_edit.field_delete_modal.title": "Poistetaanko mukautettu kenttä?",
  "account_edit.field_edit_modal.add_title": "Lisää mukautettu kenttä",
  "account_edit.field_edit_modal.discard_confirm": "Hylkää",
  "account_edit.field_edit_modal.discard_message": "Sinulla on tallentamattomia muutoksia. Haluatko varmasti hylätä ne?",
  "account_edit.field_edit_modal.edit_title": "Muokkaa mukautettua kenttää",
  "account_edit.field_edit_modal.length_warning": "Suositeltava merkkimäärä ylitetty. Mobiilikäyttäjät eivät välttämättä näe kenttää kokonaan.",
  "account_edit.field_edit_modal.link_emoji_warning": "Emme suosittele käyttämään mukautettuja emojeita URL-osoitteiden kanssa. Molempia sisältävät mukautetut kentät näkyvät vain tekstinä linkin sijaan, jotta estetään käyttäjien sekaannus.",
  "account_edit.field_edit_modal.name_hint": "Esim. ”Henkilökohtainen verkkosivusto”",
  "account_edit.field_edit_modal.name_label": "Nimike",
  "account_edit.field_edit_modal.url_warning": "Lisää linkki sisällyttämällä alkuun {protocol}.",
  "account_edit.field_edit_modal.value_hint": "Esim. ”https://example.me”",
  "account_edit.field_edit_modal.value_label": "Arvo",
  "account_edit.field_reorder_modal.drag_cancel": "Veto peruttu. Kenttää ”{item}” ei siirretty.",
  "account_edit.field_reorder_modal.drag_end": "Kenttä ”{item}” pudotettu.",
  "account_edit.field_reorder_modal.drag_instructions": "Järjestele mukautettuja kenttiä painamalla välilyöntiä tai Enter-näppäintä. Raahatessa siirrä kenttää ylös tai alas nuolinäppäimillä. Pudota kenttä uuteen kohtaansa painamalla uudelleen välilyöntiä tai Enter-näppäintä, tai peru painamalla Escape-näppäintä.",
  "account_edit.field_reorder_modal.drag_move": "Kenttä ”{item}” siirretty.",
  "account_edit.field_reorder_modal.drag_over": "Kenttä ”{item}” siirretty kohdan ”{over}” päälle.",
  "account_edit.field_reorder_modal.drag_start": "Valittu kenttä ”{item}”.",
  "account_edit.field_reorder_modal.handle_label": "Siirrä kenttää ”{item}”",
  "account_edit.field_reorder_modal.title": "Järjestele kenttiä",
  "account_edit.image_alt_modal.add_title": "Lisää tekstivastine",
  "account_edit.image_alt_modal.details_content": "TEE NÄIN: <ul> <li>Kuvaile itseäsi kuvan mukaisesti</li> <li>Käytä kolmannen persoonan muotoja (esim. ”Aleksi” eikä ”minä”)</li> <li>Ole ytimekäs – usein muutama sana riittää</li> </ul> ÄLÄ TEE NÄIN: <ul> <li>Aloita sanalla ”Kuva” – sen on tarpeetonta näytönlukuohjelmille</li> </ul> ESIMERKKI: <ul> <li>”Aleksi yllään vihreä paita ja lasit”</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Vinkkejä: profiilikuvien tekstivastineet",
  "account_edit.image_alt_modal.edit_title": "Muokkaa tekstivastinetta",
  "account_edit.image_alt_modal.text_hint": "Tekstivastine auttaa näytönlukuohjelmien käyttäjiä ymmärtämään sisältöä.",
  "account_edit.image_alt_modal.text_label": "Tekstivastine",
  "account_edit.image_delete_modal.confirm": "Haluatko varmasti poistaa tämän kuvan? Tätä toimea ei voi kumota.",
  "account_edit.image_delete_modal.delete_button": "Poista",
  "account_edit.image_delete_modal.title": "Poistetaanko kuva?",
  "account_edit.image_edit.add_button": "Lisää kuva",
  "account_edit.image_edit.alt_add_button": "Lisää tekstivastine",
  "account_edit.image_edit.alt_edit_button": "Muokkaa tekstivastinetta",
  "account_edit.image_edit.remove_button": "Poista kuva",
  "account_edit.image_edit.replace_button": "Korvaa kuva",
  "account_edit.item_list.delete": "Poista {name}",
  "account_edit.item_list.edit": "Muokkaa kohdetta {name}",
  "account_edit.name_modal.add_title": "Lisää näyttönimi",
  "account_edit.name_modal.edit_title": "Muokkaa näyttönimeä",
  "account_edit.profile_tab.button_label": "Mukauta",
  "account_edit.profile_tab.hint.description": "Nämä asetukset mukauttavat sitä, mitä käyttäjät näkevät palvelimella {server} virallisissa sovelluksissa, mutta ne eivät välttämättä vaikuta muiden palvelinten tai kolmannen osapuolen sovellusten käyttäjiin.",
  "account_edit.profile_tab.hint.title": "Näkymät vaihtelevat edelleen",
  "account_edit.profile_tab.show_featured.description": "”Esittelyssä” on valinnainen välilehti, jossa voit esitellä muita tilejä.",
  "account_edit.profile_tab.show_featured.title": "Näytä Esittelyssä-välilehti",
  "account_edit.profile_tab.show_media.description": "”Media” on valinnainen välilehti, joka näyttää kuvia tai videoita sisältävät julkaisusi.",
  "account_edit.profile_tab.show_media.title": "Näytä Media-välilehti",
  "account_edit.profile_tab.show_media_replies.description": "Kun käytössä, Media-välilehti näyttää sekä julkaisusi että vastauksesi muiden julkaisuihin.",
  "account_edit.profile_tab.show_media_replies.title": "Sisällytä vastaukset Media-välilehdelle",
  "account_edit.profile_tab.show_relations.description": "Näytä seuraamasi tilit ja seuraajasi muille käyttäjille profiilissasi. Muut näkevät silti, seuraatko heitä.",
  "account_edit.profile_tab.show_relations.title": "Näytä ”Seuraajat” ja ”Seurattavat”",
  "account_edit.profile_tab.subtitle": "Mukauta, kuinka profiilisi näkyy.",
  "account_edit.profile_tab.title": "Profiilin näyttöasetukset",
  "account_edit.save": "Tallenna",
  "account_edit.upload_modal.back": "Takaisin",
  "account_edit.upload_modal.done": "Valmis",
  "account_edit.upload_modal.next": "Seuraava",
  "account_edit.upload_modal.step_crop.zoom": "Lähennä/loitonna",
  "account_edit.upload_modal.step_upload.button": "Selaa tiedostoja",
  "account_edit.upload_modal.step_upload.dragging": "Lähetä pudottamalla",
  "account_edit.upload_modal.step_upload.header": "Valitse kuva",
  "account_edit.upload_modal.step_upload.hint": "WEBP-, PNG-, GIF- tai JPG-muotoinen, enintään {limit} Mt.{br}Kuva skaalautuu kokoon {width}×{height} px.",
  "account_edit.upload_modal.title_add.avatar": "Lisää profiilikuva",
  "account_edit.upload_modal.title_add.header": "Lisää kansikuva",
  "account_edit.upload_modal.title_replace.avatar": "Korvaa profiilikuva",
  "account_edit.upload_modal.title_replace.header": "Korvaa kansikuva",
  "account_edit.verified_modal.details": "Lisää Mastodon-profiiliisi uskottavuutta vahvistamalla linkit henkilökohtaisiin verkkosivustoihin. Näin se toimii:",
  "account_edit.verified_modal.invisible_link.details": "Lisää linkki HTML:n head-osaan. Tärkeä kohta on rel=\"me\", joka estää toiseksi tekeytymisen sivustoilla, joilla on käyttäjien luomaa sisältöä. Voit jopa käyttää link-tunnistetta sivun head-osassa {tag}-tunnisteen sijaan, mutta HTML:n tulee olla saatavilla suorittamatta JavaScriptia.",
  "account_edit.verified_modal.invisible_link.summary": "Miten teen linkistä näkymättömän?",
  "account_edit.verified_modal.step1.header": "Kopioi alla oleva HTML-koodi ja liitä se verkkosivustosi head-osaan",
  "account_edit.verified_modal.step2.details": "Jos olet jo lisännyt verkkosivustosi mukautettuna kenttänä, sinun tulee poistaa ja lisätä se uudelleen, jotta voit käynnistää vahvistuksen.",
  "account_edit.verified_modal.step2.header": "Lisää verkkosivustosi mukautettuna kenttänä",
  "account_edit.verified_modal.title": "Miten lisätä vahvistettu linkki",
  "account_edit_tags.add_tag": "Lisää #{tagName}",
  "account_edit_tags.column_title": "Muokkaa tunnisteita",
  "account_edit_tags.help_text": "Esiteltävät aihetunnisteet auttavat käyttäjiä löytämään profiilisi ja olemaan vuorovaikutuksessa sen kanssa. Ne näkyvät suodattimina profiilisivusi Toiminta-näkymässä.",
  "account_edit_tags.max_tags_reached": "Sinulla on enimmäismäärä esiteltäviä aihetunnisteita.",
  "account_edit_tags.search_placeholder": "Syötä aihetunniste…",
  "account_edit_tags.suggestions": "Ehdotuksia:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# julkaisu} other {# julkaisua}}",
  "account_list.hidden_notice": "Tämä näkyy vain sinulle. Näytä tämä luettelo muille kohdassa <link>{page} > {modal} > {field}</link>.",
  "account_list.total": "{total, plural, one {# tili} other {# tiliä}}",
  "admin.dashboard.daily_retention": "Käyttäjien pysyvyys päivittäin rekisteröitymisen jälkeen",
  "admin.dashboard.monthly_retention": "Käyttäjien pysyvyys kuukausittain rekisteröitymisen jälkeen",
  "admin.dashboard.retention.average": "Keskimäärin",
  "admin.dashboard.retention.cohort": "Rekisteröitymis-kk.",
  "admin.dashboard.retention.cohort_size": "Uusia käyttäjiä",
  "admin.impact_report.instance_accounts": "Tilien profiilit, jotka tämä poistaisi",
  "admin.impact_report.instance_followers": "Seuraajat, jotka käyttäjämme menettäisivät",
  "admin.impact_report.instance_follows": "Seuraajat, jotka heidän käyttäjänsä menettäisivät",
  "admin.impact_report.title": "Vaikutusten yhteenveto",
  "alert.need_reload.message": "Mastodon on päivitetty. Jotkin asiat eivät välttämättä toimi oikein ennen kuin lataat sivun uudelleen.",
  "alert.rate_limited.message": "Yritä uudelleen kello {retry_time, time, medium} jälkeen.",
  "alert.rate_limited.title": "Pyyntömäärää rajoitettu",
  "alert.unexpected.message": "Tapahtui odottamaton virhe.",
  "alert.unexpected.title": "Hups!",
  "alt_text_badge.title": "Tekstivastine",
  "alt_text_modal.add_alt_text": "Lisää tekstivastine",
  "alt_text_modal.add_text_from_image": "Lisää teksti kuvasta",
  "alt_text_modal.cancel": "Peruuta",
  "alt_text_modal.change_thumbnail": "Vaihda pikkukuva",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Kuvaile tätä kuulovammallisille ihmisille…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Kuvaile tätä näkövammallisille ihmisille…",
  "alt_text_modal.done": "Valmis",
  "announcement.announcement": "Tiedote",
  "annual_report.announcement.action_build": "Koosta oma Wrapstodon",
  "annual_report.announcement.action_dismiss": "Ei kiitos",
  "annual_report.announcement.action_view": "Näytä oma Wrapstodon",
  "annual_report.announcement.description": "Tutustu toimintaasi Mastodonissa kuluneen vuoden aikana.",
  "annual_report.announcement.title": "Wrapstodon {year} on täällä",
  "annual_report.nav_item.badge": "Uusi",
  "annual_report.shared_page.donate": "Lahjoita",
  "annual_report.shared_page.footer": "Luotu {heart}:lla Mastodon-tiimin toimesta",
  "annual_report.shared_page.footer_server_info": "{username} käyttää palvelinta {domain}, yhtä monista Mastodonin tarjoamista yhteisöistä.",
  "annual_report.summary.archetype.booster.desc_public": "{name} pysyi valppaana tehostettavien julkaisujen suhteen, vahvistaen muita luojia täydellisellä tähtäyksellä.",
  "annual_report.summary.archetype.booster.desc_self": "Pysyit valppaana tehostettavien julkaisujen suhteen, vahvistaen muita luojia täydellisellä tähtäyksellä.",
  "annual_report.summary.archetype.booster.name": "Jousimies",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "Tiedämme, että {name} oli siellä jossakin, nauttien Mastodonista omalla hiljaisella tavallaan.",
  "annual_report.summary.archetype.lurker.desc_self": "Tiedämme, että olit siellä jossakin, nauttien Mastodonista omalla hiljaisella tavallasi.",
  "annual_report.summary.archetype.lurker.name": "Stoalainen",
  "annual_report.summary.archetype.oracle.desc_public": "{name} loi enemmän julkaisuja kuin vastauksia, siten pitäen Mastodonin tuoreena ja valmiina tulevaisuuteen.",
  "annual_report.summary.archetype.oracle.desc_self": "Loit enemmän julkaisuja kuin vastauksia, siten pitäen Mastodonin tuoreena ja valmiina tulevaisuuteen.",
  "annual_report.summary.archetype.oracle.name": "Oraakkeli",
  "annual_report.summary.archetype.pollster.desc_public": "{name} loi enemmän äänestyksiä kuin muita julkaisutyyppejä, siten herättäen uteliaisuutta Mastodonissa.",
  "annual_report.summary.archetype.pollster.desc_self": "Loit enemmän äänestyksiä kuin muita julkaisutyyppejä, siten herättäen uteliaisuutta Mastodonissa.",
  "annual_report.summary.archetype.pollster.name": "Ihmettelijä",
  "annual_report.summary.archetype.replier.desc_public": "{name} vastasi säännöllisesti toisten julkaisuihin, siten pölyttäen Mastodonia uusilla keskusteluilla.",
  "annual_report.summary.archetype.replier.desc_self": "Vastasit säännöllisesti toisten julkaisuihin, siten pölyttäen Mastodonia uusilla keskusteluilla.",
  "annual_report.summary.archetype.replier.name": "Perhonen",
  "annual_report.summary.archetype.reveal": "Paljasta arkkityyppini",
  "annual_report.summary.archetype.reveal_description": "Kiitos, että olet osa Mastodonia! Aika selvittää, minkä arkkityypin ruumiillistuma olit vuonna {year}.",
  "annual_report.summary.archetype.title_public": "Käyttäjän {name} arkkityyppi",
  "annual_report.summary.archetype.title_self": "Arkkityyppisi",
  "annual_report.summary.close": "Sulje",
  "annual_report.summary.copy_link": "Kopioi linkki",
  "annual_report.summary.followers.new_followers": "{count, plural, one {uusi seuraaja} other {uutta seuraajaa}}",
  "annual_report.summary.highlighted_post.boost_count": "Tätä julkaisua tehostettiin {count, plural, one {kerran} other {# kertaa}}.",
  "annual_report.summary.highlighted_post.favourite_count": "Tämä julkaisu lisättiin suosikkeihin {count, plural, one {kerran} other {# kertaa}}.",
  "annual_report.summary.highlighted_post.reply_count": "Tämä julkaisu sai {count, plural, one {1 vastauksen} other {# vastausta}}.",
  "annual_report.summary.highlighted_post.title": "Suosituin julkaisu",
  "annual_report.summary.most_used_app.most_used_app": "käytetyin sovellus",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "käytetyin aihetunniste",
  "annual_report.summary.most_used_hashtag.used_count": "Sisällytit tämän aihetunnisteen {count, plural, one {1 julkaisuun} other {# julkaisuun}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} sisällytti tämän aihetunnisteen {count, plural, one {1 julkaisuun} other {# julkaisuun}}.",
  "annual_report.summary.new_posts.new_posts": "uutta julkaisua",
  "annual_report.summary.percentile.text": "<topLabel>Olet osa huippujoukkoa, johon kuuluu</topLabel><percentage></percentage><bottomLabel>{domain}-käyttäjistä.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Emme kerro Bernie Sandersille.",
  "annual_report.summary.share_elsewhere": "Jaa muualla",
  "annual_report.summary.share_message": "Arkkityyppini on {archetype}!",
  "annual_report.summary.share_on_mastodon": "Jaa Mastodonissa",
  "attachments_list.unprocessed": "(käsittelemätön)",
  "audio.hide": "Piilota ääni",
  "block_modal.no_collections": "Kumpikaan teistä ei voi lisätä toista kokoelmiin. Sinut poistetaan automaattisesti kummankin mahdollisista olemassa olevista kokoelmista.",
  "block_modal.remote_users_caveat": "Pyydämme palvelinta {domain} kunnioittamaan päätöstäsi. Myötämielisyyttä ei kuitenkaan taata, koska jotkin palvelimet voivat käsitellä estoja eri tavalla. Julkiset julkaisut voivat silti näkyä kirjautumattomille käyttäjille.",
  "block_modal.show_less": "Näytä vähemmän",
  "block_modal.show_more": "Näytä enemmän",
  "block_modal.they_cant_mention": "Ette voi mainita, seurata ettekä lainata toisianne.",
  "block_modal.they_cant_see_posts": "Hän ei voi nähdä sisältöäsi, etkä sinä näe enää hänen.",
  "block_modal.they_will_know": "Hän voi nähdä, että hänet on estetty.",
  "block_modal.title": "Estetäänkö käyttäjä?",
  "block_modal.you_wont_see_mentions": "Et näe enää muiden käyttäjien julkaisuja, joissa hänet mainitaan.",
  "boost_modal.combo": "Ensi kerralla voit ohittaa tämän painamalla {combo}",
  "boost_modal.reblog": "Tehostetaanko julkaisua?",
  "boost_modal.undo_reblog": "Perutaanko julkaisun tehostus?",
  "bundle_column_error.copy_stacktrace": "Kopioi virheraportti",
  "bundle_column_error.error.body": "Pyydettyä sivua ei voitu hahmontaa. Se voi johtua virheestä koodissamme tai selaimen yhteensopivuudessa.",
  "bundle_column_error.error.title": "Voi ei!",
  "bundle_column_error.network.body": "Sivun lataamisessa tapahtui virhe. Tämä voi johtua tilapäisestä Internet-yhteyden tai tämän palvelimen ongelmasta.",
  "bundle_column_error.network.title": "Verkkovirhe",
  "bundle_column_error.retry": "Yritä uudelleen",
  "bundle_column_error.return": "Palaa takaisin kotiin",
  "bundle_column_error.routing.body": "Pyydettyä sivua ei löytynyt. Oletko varma, että osoitepalkin URL-osoite on oikein?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Sulje",
  "bundle_modal_error.message": "Jotain meni pieleen tätä näyttöä ladattaessa.",
  "bundle_modal_error.retry": "Yritä uudelleen",
  "callout.dismiss": "Hylkää",
  "carousel.current": "<sr>Dia</sr> {current, number} / {max, number}",
  "carousel.slide": "Dia {current, number} / {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} suositeltua merkkiä",
  "character_counter.required": "{currentLength}/{maxLength} merkkiä",
  "closed_registrations.other_server_instructions": "Koska Mastodon on hajautettu, voit luoda tilin toiselle palvelimelle ja olla silti vuorovaikutuksessa tämän kanssa.",
  "closed_registrations_modal.description": "Tilin luonti palvelimelle {domain} ei tällä hetkellä ole mahdollista, mutta ota huomioon, ettei Mastodonin käyttö edellytä juuri kyseisen palvelimen tiliä.",
  "closed_registrations_modal.find_another_server": "Etsi toinen palvelin",
  "closed_registrations_modal.preamble": "Mastodon on hajautettu, joten riippumatta siitä, missä luot tilisi, voit seurata ja olla vuorovaikutuksessa kenen tahansa kanssa tällä palvelimella. Voit jopa isännöidä palvelinta!",
  "closed_registrations_modal.title": "Rekisteröityminen Mastodoniin",
  "collection.share_modal.share_link_label": "Jaa linkki",
  "collection.share_modal.share_via_post": "Jaa Mastodonissa",
  "collection.share_modal.share_via_system": "Jaa kohteeseen…",
  "collection.share_modal.title": "Jaa kokoelma",
  "collection.share_modal.title_new": "Jaa uusi kokoelmasi!",
  "collection.share_template_other": "Katso tämä siisti kokoelma:",
  "collection.share_template_own": "Katso uusi kokoelmani:",
  "collections.account_count": "{count, plural, one {# tili} other {# tiliä}}",
  "collections.accounts.empty_description": "Lisää enintään {count} tiliä",
  "collections.accounts.empty_editor_title": "Kukaan ei ole vielä tässä kokoelmassa",
  "collections.accounts.empty_title": "Tämä kokoelma on tyhjä",
  "collections.add_to_collection": "Lisää {name} kokoelmiin",
  "collections.block_collection_owner": "Estä tili",
  "collections.by_account": "koonnut {account_handle}",
  "collections.collection_description": "Kuvaus",
  "collections.collection_language": "Kieli",
  "collections.collection_language_none": "Ei mikään",
  "collections.collection_name": "Nimi",
  "collections.collection_topic": "Aihe",
  "collections.confirm_account_removal": "Haluatko varmasti poistaa tämän tilin tästä kokoelmasta?",
  "collections.content_warning": "Sisältövaroitus",
  "collections.continue": "Jatka",
  "collections.copy_link": "Kopioi linkki",
  "collections.copy_link_confirmation": "Kokoelman linkki kopioitu leikepöydälle",
  "collections.create.accounts_title": "Keitä esittelet tässä kokoelmassa?",
  "collections.create.basic_details_title": "Perustiedot",
  "collections.create.steps": "Vaihe {step}/{total}",
  "collections.create_collection": "Luo kokoelma",
  "collections.create_new_collection": "Luo uusi kokoelma",
  "collections.delete_collection": "Poista kokoelma",
  "collections.description_length_hint": "100 merkin rajoitus",
  "collections.detail.author_added_you_on_date": "{author} lisäsi sinut {date}",
  "collections.detail.loading": "Ladataan kokoelmaa…",
  "collections.detail.revoke_inclusion": "Poista minut",
  "collections.detail.sensitive_content": "Arkaluonteista sisältöä",
  "collections.detail.sensitive_note": "Kuvaus ja tilit eivät välttämättä sovellu kaikille.",
  "collections.detail.share": "Jaa tämä kokoelma",
  "collections.detail.you_are_in_this_collection": "Esiinnyt tässä kokoelmassa",
  "collections.edit_details": "Muokkaa tietoja",
  "collections.error_loading_collections": "Näiden kokoelmien latauksessa tapahtui virhe.",
  "collections.hidden_accounts_description": "Olet estänyt tai mykistänyt {count, plural, one {tämän käyttäjän} other {nämä käyttäjät}}",
  "collections.hidden_accounts_link": "{count, plural, one {# piilotettu tili} other {# piilotettua tiliä}}",
  "collections.hints.accounts_counter": "{count}/{max} tiliä",
  "collections.last_updated_at": "Päivitetty viimeksi {date}",
  "collections.list.collections_with_count": "{count, plural, one {# kokoelma} other {# kokoelmaa}}",
  "collections.list.created_by_author": "Luonut {name}",
  "collections.list.created_by_you": "Itse luomasi",
  "collections.list.featuring_you": "Esittelevät sinua",
  "collections.manage_accounts": "Hallitse tilejä",
  "collections.mark_as_sensitive": "Merkitse arkaluonteiseksi",
  "collections.mark_as_sensitive_hint": "Piilottaa kokoelman kuvauksen ja tilit sisältövaroituksen taakse. Kokoelman nimi jää esiin.",
  "collections.maximum_collection_count_description": "Palvelimesi sallii enintään {count} kokoelman luomisen.",
  "collections.maximum_collection_count_reached": "Olet luonut enimmäismäärän kokoelmia",
  "collections.name_length_hint": "40 merkin rajoitus",
  "collections.new_collection": "Uusi kokoelma",
  "collections.pending_accounts.message": "Tilit saattavat näkyä odottavina, kun odotetaan vastausta käyttäjältä tai hänen palvelimeltaan. Vain sinä voit nähdä odottavat tilit.",
  "collections.pending_accounts.title": "Miksi näen odottavia tilejä?",
  "collections.remove_account": "Poista",
  "collections.report_collection": "Raportoi tämä kokoelma",
  "collections.revoke_collection_inclusion": "Poista itseni tästä kokoelmasta",
  "collections.revoke_inclusion.confirmation": "Sinut on poistettu kokoelmasta ”{collection}”",
  "collections.revoke_inclusion.error": "Tapahtui virhe – yritä myöhemmin uudelleen.",
  "collections.search_accounts_label": "Hae lisättävää tiliä",
  "collections.search_accounts_max_reached": "Olet lisännyt enimmäismäärän tilejä",
  "collections.sensitive": "Arkaluonteinen",
  "collections.share_short": "Jaa",
  "collections.sort_alphabetical": "Aakkosjärjestys",
  "collections.sort_by": "Järjestys:",
  "collections.sort_date_added": "Lisäyspäivämäärä",
  "collections.sort_last_active": "Viimeksi aktiivisena",
  "collections.sort_most_followers": "Eniten seuraajia",
  "collections.suggestions.can_not_add": "Ei voi lisätä",
  "collections.suggestions.can_not_add_desc": "Nämä tilit ovat ehkä jättäytyneet löydettävyyden ulkopuolelle, tai ne saattavat olla palvelimella, joka ei tue kokoelmia.",
  "collections.suggestions.must_follow": "Täytyy ensin seurata",
  "collections.suggestions.must_follow_desc": "Nämä tilit tarkistavat kaikki seurantapyynnöt. Seuraajat voivat lisätä niitä kokoelmiinsa.",
  "collections.topic_hint": "Lisää aihetunniste, joka auttaa muita ymmärtämään tämän kokoelman pääaiheen.",
  "collections.topic_special_chars_hint": "Erikoismerkit poistetaan tallennettaessa",
  "collections.unlisted_collections_description": "Nämä eivät näy muille profiilissasi. Kuka tahansa, jolla on linkki, voi löytää ne.",
  "collections.unlisted_collections_with_count": "Listaamattomat kokoelmat ({count})",
  "collections.view_collection": "Näytä kokoelma",
  "collections.visibility_public": "Julkinen",
  "collections.visibility_public_hint": "Löydettävissä hakutuloksista ja muualta, jossa ilmenee suosituksia.",
  "collections.visibility_title": "Näkyvyys",
  "collections.visibility_unlisted": "Listaamaton",
  "collections.visibility_unlisted_hint": "Näkyy kaikille, joilla on linkki. Piilotetaan hakutuloksista ja suosituksista.",
  "column.about": "Tietoja",
  "column.blocks": "Estetyt käyttäjät",
  "column.bookmarks": "Kirjanmerkit",
  "column.community": "Paikallinen aikajana",
  "column.create_list": "Luo lista",
  "column.direct": "Yksityismaininnat",
  "column.directory": "Selaa profiileja",
  "column.domain_blocks": "Estetyt verkkotunnukset",
  "column.edit_list": "Muokkaa listaa",
  "column.favourites": "Suosikit",
  "column.firehose": "Livesyötteet",
  "column.firehose_local": "Tämän palvelimen livesyöte",
  "column.firehose_singular": "Livesyöte",
  "column.follow_requests": "Seurantapyynnöt",
  "column.home": "Koti",
  "column.list_members": "Hallitse listan jäseniä",
  "column.lists": "Listat",
  "column.mutes": "Mykistetyt käyttäjät",
  "column.notifications": "Ilmoitukset",
  "column.other_collections": "Käyttäjän {name} kokoelmat",
  "column.pins": "Kiinnitetyt julkaisut",
  "column.public": "Yleinen aikajana",
  "column.your_collections": "Omat kokoelmat",
  "column_back_button.label": "Takaisin",
  "column_header.hide_settings": "Piilota asetukset",
  "column_header.moveLeft_settings": "Siirrä saraketta vasemmalle",
  "column_header.moveRight_settings": "Siirrä saraketta oikealle",
  "column_header.pin": "Kiinnitä",
  "column_header.show_settings": "Näytä asetukset",
  "column_header.unpin": "Irrota",
  "column_search.cancel": "Peruuta",
  "combobox.close_results": "Sulje tulokset",
  "combobox.loading": "Ladataan",
  "combobox.no_results_found": "Ei tuloksia tälle haulle",
  "combobox.open_results": "Avaa tulokset",
  "combobox.results_available": "Saatavilla {count, plural, one {# ehdotus} other {# ehdotusta}}. Navigoi käyttämällä nuoli ylös- ja nuoli alas -näppäimiä. Valitse painamalla Enter.",
  "community.column_settings.local_only": "Vain paikalliset",
  "community.column_settings.media_only": "Vain media",
  "community.column_settings.remote_only": "Vain etätilit",
  "compose.error.blank_post": "Julkaisu ei voi olla tyhjä.",
  "compose.language.change": "Vaihda kieli",
  "compose.language.search": "Hae kieliä…",
  "compose.published.body": "Julkaisu lähetetty.",
  "compose.published.open": "Avaa",
  "compose.saved.body": "Julkaisu tallennettu.",
  "compose_form.direct_message_warning_learn_more": "Lue lisää",
  "compose_form.encryption_warning": "Mastodonin julkaisut eivät ole päästä päähän salattuja. Älä jaa arkaluonteisia tietoja Mastodonissa.",
  "compose_form.hashtag_warning": "Tätä julkaisua ei voi liittää aihetunnisteisiin, koska se ei ole julkinen. Vain näkyvyydeltään julkisiksi määritettyjä julkaisuja voidaan hakea aihetunnisteiden avulla.",
  "compose_form.lock_disclaimer": "Tilisi ei ole {locked}. Kuka tahansa voi seurata tiliäsi ja nähdä vain seuraajille rajaamasi julkaisut.",
  "compose_form.lock_disclaimer.lock": "lukittu",
  "compose_form.placeholder": "Mitä mietit?",
  "compose_form.poll.duration": "Äänestyksen kesto",
  "compose_form.poll.multiple": "Monivalinta",
  "compose_form.poll.option_placeholder": "Vaihtoehto {number}",
  "compose_form.poll.single": "Yksittäisvalinta",
  "compose_form.poll.switch_to_multiple": "Muuta äänestys monivalinnaksi",
  "compose_form.poll.switch_to_single": "Muuta äänestys yksittäisvalinnaksi",
  "compose_form.poll.type": "Tyyli",
  "compose_form.publish": "Julkaise",
  "compose_form.reply": "Vastaa",
  "compose_form.save_changes": "Päivitä",
  "compose_form.spoiler.marked": "Poista sisältövaroitus",
  "compose_form.spoiler.unmarked": "Lisää sisältövaroitus",
  "compose_form.spoiler_placeholder": "Sisältövaroitus (valinnainen)",
  "confirmation_modal.cancel": "Peruuta",
  "confirmations.block.confirm": "Estä",
  "confirmations.delete.confirm": "Poista",
  "confirmations.delete.message": "Haluatko varmasti poistaa tämän julkaisun?",
  "confirmations.delete.title": "Poistetaanko julkaisu?",
  "confirmations.delete_collection.confirm": "Poista",
  "confirmations.delete_collection.message": "Tätä toimea ei voi peruuttaa.",
  "confirmations.delete_collection.title": "Poistetaanko ”{name}”?",
  "confirmations.delete_list.confirm": "Poista",
  "confirmations.delete_list.message": "Haluatko varmasti poistaa tämän listan pysyvästi?",
  "confirmations.delete_list.title": "Poistetaanko lista?",
  "confirmations.discard_draft.confirm": "Hylkää ja jatka",
  "confirmations.discard_draft.edit.cancel": "Palaa muokkaamaan",
  "confirmations.discard_draft.edit.message": "Jatkaminen tuhoaa kaikki muutokset, joita olet tehnyt julkaisuun, jota olet parhaillaan muokkaamassa.",
  "confirmations.discard_draft.edit.title": "Hylätäänkö luonnosjulkaisusi muutokset?",
  "confirmations.discard_draft.post.cancel": "Palaa luonnokseen",
  "confirmations.discard_draft.post.message": "Jatkaminen tuhoaa julkaisun, jota olet parhaillaan laatimassa.",
  "confirmations.discard_draft.post.title": "Hylätäänkö luonnosjulkaisusi?",
  "confirmations.discard_edit_media.confirm": "Hylkää",
  "confirmations.discard_edit_media.message": "Sinulla on tallentamattomia muutoksia median kuvaukseen tai esikatseluun. Hylätäänkö ne silti?",
  "confirmations.follow_to_list.confirm": "Seuraa ja lisää listaan",
  "confirmations.follow_to_list.message": "Sinun on seurattava käyttäjää {name}, jotta voit lisätä hänet listaan.",
  "confirmations.follow_to_list.title": "Seurataanko käyttäjää?",
  "confirmations.hide_featured_tab.confirm": "Piilota välilehti",
  "confirmations.hide_featured_tab.intro": "Voit muuttaa tätä milloin tahansa kohdasta <i>Muokkaa profiilia > Profiilin välilehtien asetukset</i>.",
  "confirmations.hide_featured_tab.message": "Tämä piilottaa välilehden palvelimen {serverName} käyttäjiltä ja muilta palvelimilta, jotka toimivat Mastodonin uusimmalla versiolla. Muut näkymät voivat vaihdella.",
  "confirmations.hide_featured_tab.title": "Piilotetaanko Esittelyssä-välilehti?",
  "confirmations.logout.confirm": "Kirjaudu ulos",
  "confirmations.logout.message": "Haluatko varmasti kirjautua ulos?",
  "confirmations.logout.title": "Kirjaudutaanko ulos?",
  "confirmations.missing_alt_text.confirm": "Lisää tekstivastine",
  "confirmations.missing_alt_text.message": "Julkaisussasi on mediaa ilman tekstivastinetta. Kuvausten lisääminen auttaa tekemään sisällöstäsi saavutettavamman useammille ihmisille.",
  "confirmations.missing_alt_text.secondary": "Julkaise silti",
  "confirmations.missing_alt_text.title": "Lisätäänkö tekstivastine?",
  "confirmations.mute.confirm": "Mykistä",
  "confirmations.private_quote_notify.cancel": "Takaisin muokkaukseen",
  "confirmations.private_quote_notify.confirm": "Julkaise",
  "confirmations.private_quote_notify.do_not_show_again": "Älä näytä tätä viestiä uudelleen",
  "confirmations.private_quote_notify.message": "Lainaamasi käyttäjä ja muut mainitut saavat ilmoituksen ja voivat tarkastella julkaisuasi, vaikka he eivät seuraisi sinua.",
  "confirmations.private_quote_notify.title": "Jaetaanko seuraajien ja mainittujen käyttäjien kanssa?",
  "confirmations.quiet_post_quote_info.dismiss": "Älä muistuta minua uudelleen",
  "confirmations.quiet_post_quote_info.got_it": "Selvä",
  "confirmations.quiet_post_quote_info.message": "Kun lainaat vaivihkaa julkisia julkaisuja, oma julkaisusi piilotetaan suosittujen julkaisujen aikajanoilta.",
  "confirmations.quiet_post_quote_info.title": "Lainataan vaivihkaa julkista julkaisua",
  "confirmations.redraft.confirm": "Poista ja palauta muokattavaksi",
  "confirmations.redraft.message": "Haluatko varmasti poistaa julkaisun ja tehdä siitä luonnoksen? Suosikit ja tehostukset menetetään, ja alkuperäisen julkaisun vastaukset jäävät orvoiksi.",
  "confirmations.redraft.title": "Poistetaanko julkaisu ja palautetaanko se muokattavaksi?",
  "confirmations.remove_from_followers.confirm": "Poista seuraaja",
  "confirmations.remove_from_followers.message": "{name} lakkaa seuraamasta sinua. Haluatko varmasti jatkaa?",
  "confirmations.remove_from_followers.title": "Poistetaanko seuraaja?",
  "confirmations.revoke_collection_inclusion.confirm": "Poista minut",
  "confirmations.revoke_collection_inclusion.message": "Kokoaja ei voi lisätä sinua uudelleen tähän kokoelmaan seuraavan 24 tunnin aikana. Estämällä hänet voit pysyvästi estää häntä lisäämästä sinua kokoelmiin.",
  "confirmations.revoke_collection_inclusion.title": "Poistetaanko itsesi tästä kokoelmasta?",
  "confirmations.revoke_quote.confirm": "Poista julkaisu",
  "confirmations.revoke_quote.message": "Tätä toimea ei voi peruuttaa.",
  "confirmations.revoke_quote.title": "Poistetaanko julkaisu?",
  "confirmations.unblock.confirm": "Kumoa esto",
  "confirmations.unblock.title": "Kumotaanko käyttäjän {name} esto?",
  "confirmations.unfollow.confirm": "Lopeta seuraaminen",
  "confirmations.unfollow.title": "Lopetetaanko käyttäjän {name} seuraaminen?",
  "confirmations.withdraw_request.confirm": "Peruuta pyyntö",
  "confirmations.withdraw_request.title": "Peruutetaanko pyyntö seurata käyttäjää {name}?",
  "content_warning.hide": "Piilota julkaisu",
  "content_warning.show": "Näytä kuitenkin",
  "content_warning.show_more": "Näytä lisää",
  "content_warning.show_short": "Näytä",
  "conversation.delete": "Poista keskustelu",
  "conversation.mark_as_read": "Merkitse luetuksi",
  "conversation.open": "Näytä keskustelu",
  "conversation.with": "{names} kanssa",
  "copy_icon_button.copied": "Kopioitu leikepöydälle",
  "copy_icon_button.copy_this_text": "Kopioi linkki leikepöydälle",
  "copypaste.copied": "Kopioitu",
  "copypaste.copy_to_clipboard": "Kopioi leikepöydälle",
  "custom_homepage.about": "Tietoja",
  "custom_homepage.about_this_server": "Tietoja tästä palvelimesta",
  "custom_homepage.administered_by": "Ylläpitäjänä",
  "custom_homepage.contact": "Yhteydenotto:",
  "custom_homepage.latest_activity": "Viimeisin toiminta",
  "custom_homepage.these_are_the_latest_posts": "Nämä ovat tämän palvelimen 40 viimeisintä julkaisua.",
  "directory.federated": "Tunnetusta fediversumista",
  "directory.local": "Vain palvelimelta {domain}",
  "directory.new_arrivals": "Äskettäin saapuneet",
  "directory.recently_active": "Hiljattain aktiiviset",
  "disabled_account_banner.account_settings": "Tilin asetukset",
  "disabled_account_banner.text": "Tilisi {disabledAccount} on tällä hetkellä poissa käytöstä.",
  "dismissable_banner.community_timeline": "Nämä ovat tuoreimpia julkaisuja käyttäjiltä, joiden tili on palvelimella {domain}.",
  "dismissable_banner.dismiss": "Hylkää",
  "dismissable_banner.public_timeline": "Nämä ovat tuoreimpia julkaisuja fediversumin käyttäjiltä, joita seurataan palvelimella {domain}.",
  "domain_block_modal.block": "Estä palvelin",
  "domain_block_modal.block_account_instead": "Estä sen sijaan @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Tämän palvelimen käyttäjät eivät voi olla vuorovaikutuksessa vanhojen julkaisujesi kanssa.",
  "domain_block_modal.they_cant_follow": "Kukaan tältä palvelimelta ei voi seurata sinua.",
  "domain_block_modal.they_wont_know": "Hän ei saa tietää tulleensa estetyksi.",
  "domain_block_modal.title": "Estetäänkö verkkotunnus?",
  "domain_block_modal.you_will_lose_num_followers": "Menetät {followersCount, plural, one {{followersCountDisplay}:n seuraajasi} other {{followersCountDisplay} seuraajaasi}} ja {followingCount, plural, one {{followingCountDisplay}:n seurattavasi} other {{followingCountDisplay} seurattavaasi}}.",
  "domain_block_modal.you_will_lose_relationships": "Menetät kaikki tämän palvelimen seuraajasi ja seurattavasi.",
  "domain_block_modal.you_wont_see_posts": "Et enää näe julkaisuja etkä ilmoituksia tämän palvelimen käyttäjiltä.",
  "dropdown.empty": "Valitse vaihtoehto",
  "email_subscriptions.email": "Sähköpostiosoite",
  "email_subscriptions.form.action": "Tilaa",
  "email_subscriptions.form.bottom": "Saa julkaisut Saapuneet-kansioosi luomatta Mastodon-tiliä. Peruuta tilaus milloin tahansa. Jos haluat lisätietoja, katso <a>tietosuojakäytäntö</a>.",
  "email_subscriptions.form.title": "Tilaa sähköpostipäivitykset käyttäjältä {name}",
  "email_subscriptions.submitted.lead": "Viimeistele sähköpostipäivitysten tilaus tarkistamalla Saapuneet-kansiosi.",
  "email_subscriptions.submitted.title": "Vielä yksi vaihe",
  "email_subscriptions.validation.email.blocked": "Estetty sähköpostipalveluntarjoaja",
  "email_subscriptions.validation.email.invalid": "Virheellinen sähköpostiosoite",
  "embed.instructions": "Upota julkaisu verkkosivullesi kopioimalla alla oleva koodi.",
  "embed.preview": "Tältä se näyttää:",
  "emoji_button.activity": "Aktiviteetit",
  "emoji_button.clear": "Tyhjennä",
  "emoji_button.custom": "Mukautetut",
  "emoji_button.flags": "Liput",
  "emoji_button.food": "Ruoka ja juoma",
  "emoji_button.label": "Lisää emoji",
  "emoji_button.nature": "Luonto",
  "emoji_button.not_found": "Vastaavia emojeita ei löytynyt",
  "emoji_button.objects": "Esineet",
  "emoji_button.people": "Ihmiset",
  "emoji_button.recent": "Usein käytetyt",
  "emoji_button.search": "Hae…",
  "emoji_button.search_results": "Hakutulokset",
  "emoji_button.symbols": "Symbolit",
  "emoji_button.travel": "Matkailu ja paikat",
  "empty_column.account_featured.other": "{acct} ei esittele vielä mitään.",
  "empty_column.account_featured_self.no_collections_button": "Luo kokoelma",
  "empty_column.account_featured_self.no_collections_hide_tab": "Piilota tämä välilehti sen sijaan",
  "empty_column.account_featured_self.showcase_accounts": "Esittele suosikkitilejäsi",
  "empty_column.account_featured_self.showcase_accounts_desc": "Kokoelmat ovat valikoituja listoja tileistä, jotka auttavat muita löytämään enemmän fediversumissa.",
  "empty_column.account_featured_unknown.other": "Tämä tili ei esittele vielä mitään.",
  "empty_column.account_hides_collections": "Käyttäjä on päättänyt pitää nämä tiedot yksityisinä",
  "empty_column.account_suspended": "Tili jäädytetty",
  "empty_column.account_timeline": "Ei julkaisuja täällä!",
  "empty_column.account_unavailable": "Profiili ei saatavilla",
  "empty_column.blocks": "Et ole vielä estänyt käyttäjiä.",
  "empty_column.bookmarked_statuses": "Sinulla ei ole vielä kirjanmerkkeihin lisättyjä julkaisuja. Kun lisäät julkaisun kirjanmerkkeihin, se tulee tähän näkyviin.",
  "empty_column.collections": "{acct} ei ole luonut vielä yhtään kokoelmaa.",
  "empty_column.collections.featured_in": "Sinua ei ole vielä lisätty mihinkään kokoelmaan.",
  "empty_column.collections.featured_in_undiscoverable": "Jotta sinut voi lisätä kokoelmiin, esittely löydettävyyskokemuksissa on sallittava kohdassa <link>Asetukset > Yksityisyys ja tavoittavuus</link>",
  "empty_column.collections_self": "Et ole luonut vielä yhtään kokoelmaa.",
  "empty_column.community": "Paikallinen aikajana on tyhjä. Kirjoita jotain julkista, niin homma lähtee käyntiin!",
  "empty_column.direct": "Sinulla ei ole vielä yksityismainintoja. Kun lähetät tai vastaanotat sellaisen, se tulee tähän näkyviin.",
  "empty_column.disabled_feed": "Palvelimen ylläpito on poistanut käytöstä tämän syötteen.",
  "empty_column.domain_blocks": "Verkkotunnuksia ei ole vielä estetty.",
  "empty_column.explore_statuses": "Mikään ei ole nyt suosittua. Tarkista myöhemmin uudelleen!",
  "empty_column.favourited_statuses": "Sinulla ei ole vielä suosikkijulkaisuja. Kun lisäät sellaisen, se tulee tähän näkyviin.",
  "empty_column.favourites": "Kukaan ei ole vielä lisännyt tätä julkaisua suosikkeihinsa. Kun joku tekee niin, hän tulee tähän näkyviin.",
  "empty_column.follow_requests": "Sinulla ei ole vielä seurantapyyntöjä. Kun saat sellaisen, se tulee tähän näkyviin.",
  "empty_column.followed_tags": "Et seuraa vielä yhtäkään aihetunnistetta. Kun alat seurata, ne tulevat tähän näkyviin.",
  "empty_column.hashtag": "Tällä aihetunnisteella ei löydy vielä sisältöä.",
  "empty_column.home": "Kotiaikajanasi on tyhjä! Seuraa useampia käyttäjiä, niin näet enemmän sisältöä.",
  "empty_column.list": "Tässä listassa ei ole vielä mitään. Kun tämän listan jäsenet lähettävät uusia julkaisuja, ne näkyvät tässä.",
  "empty_column.mutes": "Et ole mykistänyt vielä yhtään käyttäjää.",
  "empty_column.notification_requests": "Olet ajan tasalla! Täällä ei ole mitään uutta kerrottavaa. Kun saat uusia ilmoituksia, ne näkyvät täällä asetustesi mukaisesti.",
  "empty_column.notifications": "Sinulla ei ole vielä ilmoituksia. Kun muut ovat vuorovaikutuksessa kanssasi, näet sen täällä.",
  "empty_column.public": "Täällä ei ole mitään! Kirjoita jotain julkisesti tai seuraa muiden palvelinten käyttäjiä, niin saat sisältöä",
  "empty_state.no_results": "Ei tuloksia",
  "error.no_hashtag_feed_access": "Liity tai kirjaudu sisään, niin voit tarkastella ja seurata tätä aihetunnistetta.",
  "error.unexpected_crash.explanation": "Sivua ei voida näyttää oikein ohjelmointivirheen tai selaimen yhteensopivuusvajeen vuoksi.",
  "error.unexpected_crash.explanation_addons": "Sivua ei voitu näyttää oikein. Tämä virhe johtuu todennäköisesti selaimen lisäosasta tai automaattisista käännöstyökaluista.",
  "error.unexpected_crash.next_steps": "Kokeile päivittää sivu. Jos se ei auta, Mastodonin käyttö voi ehkä onnistua eri selaimella tai natiivisovelluksella.",
  "error.unexpected_crash.next_steps_addons": "Yritä poistaa ne käytöstä, ja virkistä sitten sivunlataus. Mikäli ongelma jatkuu, voit mahdollisesti käyttää Mastodonia eri selaimella tai natiivilla sovelluksella.",
  "errors.unexpected_crash.copy_stacktrace": "Kopioi pinon jäljitys leikepöydälle",
  "errors.unexpected_crash.report_issue": "Ilmoita ongelmasta",
  "explore.suggested_follows": "Käyttäjät",
  "explore.title": "Suosittua",
  "explore.trending_links": "Uutiset",
  "explore.trending_statuses": "Julkaisut",
  "explore.trending_tags": "Aihetunnisteet",
  "featured_carousel.current": "<sr>Julkaisu</sr> {current, number} / {max, number}",
  "featured_carousel.header": "{count, plural, one {Kiinnitetty julkaisu} other {Kiinnitetyt julkaisut}}",
  "featured_carousel.slide": "Julkaisu {current, number} / {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "Olet viime aikoina julkaissut aiheista {items}. Lisätäänkö nämä esiteltäviksi aihetunnisteiksi?",
  "featured_tags.suggestions.add": "Lisää",
  "featured_tags.suggestions.added": "Hallitse esiteltäviä aihetunnisteitasi milloin tahansa kohdasta <link>Muokkaa profiilia > Esiteltävät aihetunnisteet</link>.",
  "featured_tags.suggestions.dismiss": "Ei kiitos",
  "filter_modal.added.context_mismatch_explanation": "Tämä suodatinluokka ei koske asiayhteyttä, jossa olet tarkastellut tätä julkaisua. Jos haluat julkaisun suodatettavan myös tässä asiayhteydessä, muokkaa suodatinta.",
  "filter_modal.added.context_mismatch_title": "Asiayhteys ei täsmää!",
  "filter_modal.added.expired_explanation": "Tämä suodatinluokka on vanhentunut, joten sinun on muutettava viimeistä voimassaolopäivää, jotta suodatusta käytettäisiin.",
  "filter_modal.added.expired_title": "Vanhentunut suodatin!",
  "filter_modal.added.review_and_configure": "Voit tarkastella tätä suodatinluokkaa ja määrittää sen tarkemmin {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Suodattimen asetukset",
  "filter_modal.added.settings_link": "asetussivulla",
  "filter_modal.added.short_explanation": "Tämä julkaisu on lisätty seuraavaan suodatinluokkaan: {title}.",
  "filter_modal.added.title": "Suodatin lisätty!",
  "filter_modal.select_filter.context_mismatch": "ei sovellu tähän kontekstiin",
  "filter_modal.select_filter.expired": "vanhentunut",
  "filter_modal.select_filter.prompt_new": "Uusi luokka: {name}",
  "filter_modal.select_filter.search": "Hae tai luo",
  "filter_modal.select_filter.subtitle": "Käytä olemassa olevaa luokkaa tai luo uusi",
  "filter_modal.select_filter.title": "Suodata tämä julkaisu",
  "filter_modal.title.status": "Suodata julkaisu",
  "filter_warning.matches_filter": "Vastaa suodatinta ”<span>{title}</span>”",
  "filtered_notifications_banner.pending_requests": "{count, plural, =0 {Ei keneltäkään, jonka} one {1 käyttäjältä, jonka} other {# käyttäjältä, jotka}} saatat tuntea",
  "filtered_notifications_banner.title": "Suodatetut ilmoitukset",
  "firehose.all": "Kaikki",
  "firehose.local": "Tämä palvelin",
  "firehose.remote": "Muut palvelimet",
  "follow_request.authorize": "Valtuuta",
  "follow_request.reject": "Hylkää",
  "follow_requests.unlocked_explanation": "Vaikkei tiliäsi ole lukittu, palvelimen {domain} ylläpito on arvioinut, että saatat olla halukas tarkistamaan nämä seurantapyynnöt erikseen.",
  "follow_suggestions.curated_suggestion": "Ehdotus ylläpidolta",
  "follow_suggestions.dismiss": "Älä näytä uudelleen",
  "follow_suggestions.featured_longer": "Palvelimen {domain} tiimin poimintoja",
  "follow_suggestions.friends_of_friends_longer": "Suosittu seuraamiesi käyttäjien joukossa",
  "follow_suggestions.hints.featured": "Tämän profiilin on valinnut palvelimen {domain} tiimi.",
  "follow_suggestions.hints.friends_of_friends": "Tämä profiili on suosittu seuraamiesi käyttäjien joukossa.",
  "follow_suggestions.hints.most_followed": "Tämä profiili on palvelimen {domain} seuratuimpia.",
  "follow_suggestions.hints.most_interactions": "Tämä profiili on viime aikoina saanut paljon huomiota palvelimella {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Tämä profiili on samankaltainen kuin profiilit, joita olet viimeksi seurannut.",
  "follow_suggestions.personalized_suggestion": "Mukautettu ehdotus",
  "follow_suggestions.popular_suggestion": "Suosittu ehdotus",
  "follow_suggestions.popular_suggestion_longer": "Suosittu palvelimella {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Samankaltainen kuin äskettäin seuraamasi profiilit",
  "follow_suggestions.view_all": "Näytä kaikki",
  "follow_suggestions.who_to_follow": "Seurantaehdotuksia",
  "followed_tags": "Seurattavat aihetunnisteet",
  "followers.hide_other_followers": "Käyttäjä on päättänyt piilottaa muut seuraajansa",
  "followers.title": "Seurattavana {name}",
  "following.hide_other_following": "Käyttäjä on päättänyt piilottaa muut seurattavansa",
  "following.title": "Seuraajana {name}",
  "footer.about": "Tietoja",
  "footer.about_mastodon": "Tietoja Mastodonista",
  "footer.about_server": "Tietoja palvelimesta {domain}",
  "footer.about_this_server": "Tietoja",
  "footer.directory": "Profiilihakemisto",
  "footer.get_app": "Hanki sovellus",
  "footer.keyboard_shortcuts": "Pikanäppäimet",
  "footer.privacy_policy": "Tietosuojakäytäntö",
  "footer.source_code": "Näytä lähdekoodi",
  "footer.status": "Tila",
  "footer.terms_of_service": "Käyttöehdot",
  "form_error.blank": "Kenttä ei voi olla tyhjä.",
  "form_field.optional": "(valinnainen)",
  "getting_started.heading": "Näin pääset alkuun",
  "hashtag.admin_moderation": "Avaa tunnisteen #{name} moderointinäkymä",
  "hashtag.browse": "Selaa julkaisuja tunnisteella #{hashtag}",
  "hashtag.browse_from_account": "Selaa julkaisuja käyttäjältä @{name} tunnisteella #{hashtag}",
  "hashtag.column_header.tag_mode.all": "ja {additional}",
  "hashtag.column_header.tag_mode.any": "tai {additional}",
  "hashtag.column_header.tag_mode.none": "ilman {additional}",
  "hashtag.column_settings.select.no_options_message": "Ehdotuksia ei löytynyt",
  "hashtag.column_settings.select.placeholder": "Syötä aihetunnisteet…",
  "hashtag.column_settings.tag_mode.all": "Kaikki nämä",
  "hashtag.column_settings.tag_mode.any": "Mikä tahansa näistä",
  "hashtag.column_settings.tag_mode.none": "Ei mitään näistä",
  "hashtag.column_settings.tag_toggle": "Sisällytä lisätunnisteet tähän sarakkeeseen",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} osallistuja} other {{counter} osallistujaa}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} julkaisu} other {{counter} julkaisua}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} julkaisu} other {{counter} julkaisua}} tänään",
  "hashtag.feature": "Esittele profiilissa",
  "hashtag.follow": "Seuraa aihetunnistetta",
  "hashtag.mute": "Mykistä #{hashtag}",
  "hashtag.unfeature": "Kumoa profiilissa esittely",
  "hashtag.unfollow": "Lopeta aihetunnisteen seuraaminen",
  "hashtags.and_other": "…ja {count, plural, other {# lisää}}",
  "hints.profiles.followers_may_be_missing": "Tämän profiilin seuraajia saattaa puuttua.",
  "hints.profiles.follows_may_be_missing": "Tämän profiilin seurattavia saattaa puuttua.",
  "hints.profiles.posts_may_be_missing": "Tämän profiilin julkaisuja saattaa puuttua.",
  "hints.profiles.see_more_followers": "Näytä lisää seuraajia palvelimella {domain}",
  "hints.profiles.see_more_follows": "Näytä lisää seurattavia palvelimella {domain}",
  "hints.profiles.see_more_posts": "Näytä lisää julkaisuja palvelimella {domain}",
  "home.column_settings.show_quotes": "Näytä lainaukset",
  "home.column_settings.show_reblogs": "Näytä tehostukset",
  "home.column_settings.show_replies": "Näytä vastaukset",
  "home.hide_announcements": "Piilota tiedotteet",
  "home.pending_critical_update.body": "Päivitäthän Mastodon-palvelinohjelmistosi mahdollisimman pian!",
  "home.pending_critical_update.link": "Tutustu päivityssisältöihin",
  "home.pending_critical_update.title": "Kriittinen tietoturvapäivitys saatavilla!",
  "home.show_announcements": "Näytä tiedotteet",
  "ignore_notifications_modal.bots_title": "Sivuutetaanko ilmoitukset boteilta?",
  "ignore_notifications_modal.disclaimer": "Mastodon ei voi ilmoittaa käyttäjille, että olet sivuuttanut heidän ilmoituksensa. Ilmoitusten sivuuttaminen ei lopeta itse viestien lähetystä.",
  "ignore_notifications_modal.filter_instead": "Suodata sen sijaan",
  "ignore_notifications_modal.filter_to_act_users": "Voit kuitenkin yhä hyväksyä, hylätä tai raportoida käyttäjiä",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Suodatus auttaa välttämään mahdollisia sekaannuksia",
  "ignore_notifications_modal.filter_to_review_separately": "Voit käydä suodatettuja ilmoituksia läpi erikseen",
  "ignore_notifications_modal.ignore": "Sivuuta ilmoitukset",
  "ignore_notifications_modal.limited_accounts_title": "Sivuutetaanko ilmoitukset moderoiduilta tileiltä?",
  "ignore_notifications_modal.new_accounts_title": "Sivuutetaanko ilmoitukset uusilta tileiltä?",
  "ignore_notifications_modal.not_followers_title": "Sivuutetaanko ilmoitukset käyttäjiltä, jotka eivät seuraa sinua?",
  "ignore_notifications_modal.not_following_title": "Sivuutetaanko ilmoitukset käyttäjiltä, joita et seuraa?",
  "ignore_notifications_modal.private_mentions_title": "Sivuutetaanko ilmoitukset pyytämättömistä yksityismaininnoista?",
  "info_button.label": "Ohje",
  "info_button.what_is_alt_text": "<h1>Mikä tekstivastine on?</h1> <p>Tekstivastine tarjoaa kuvauksen kuvista ihmisille, joilla on näkövamma tai matalan kaistanleveyden yhteys tai jotka kaipaavat lisäkontekstia.</p> <p>Voit parantaa saavutettavuutta ja ymmärrettävyyttä kaikkien näkökulmasta kirjoittamalla selkeän, tiiviin ja objektiivisen tekstivastineen.</p> <ul> <li>Ota mukaan tärkeät elementit</li> <li>Tiivistä kuvissa oleva teksti</li> <li>Käytä tavallisia lauserakenteita</li> <li>Vältä turhaa tietoa</li> <li>Keskity trendeihin ja keskeisiin tuloksiin monimutkaisissa visuaalisissa esityksissä (kuten kaavioissa tai kartoissa)</li> </ul>",
  "interaction_modal.action": "Jotta voit olla vuorovaikutuksessa käyttäjän {name} julkaisun kanssa, sinun on kirjauduttava sisään tilillesi käyttämälläsi Mastodon-palvelimella.",
  "interaction_modal.action_follow": "Jotta voit seurata käyttäjää {name}, sinun on kirjauduttava sisään tilillesi käyttämälläsi Mastodon-palvelimella.",
  "interaction_modal.go": "Siirry",
  "interaction_modal.no_account_yet": "Eikö sinulla ole vielä tiliä?",
  "interaction_modal.on_another_server": "Toisella palvelimella",
  "interaction_modal.on_this_server": "Tällä palvelimella",
  "interaction_modal.title": "Jatka kirjautumalla sisään",
  "interaction_modal.username_prompt": "Esim. {example}",
  "intervals.full.days": "{number, plural, one {# päivä} other {# päivää}}",
  "intervals.full.hours": "{number, plural, one {# tunti} other {# tuntia}}",
  "intervals.full.minutes": "{number, plural, one {# minuutti} other {# minuuttia}}",
  "keyboard_shortcuts.back": "Siirry takaisin",
  "keyboard_shortcuts.blocked": "Avaa estettyjen käyttäjien luettelo",
  "keyboard_shortcuts.boost": "Tehosta julkaisua",
  "keyboard_shortcuts.column": "Kohdista sarakkeeseen",
  "keyboard_shortcuts.compose": "Kohdista laadintakenttään",
  "keyboard_shortcuts.description": "Kuvaus",
  "keyboard_shortcuts.direct": "Avaa yksityismainintojen sarake",
  "keyboard_shortcuts.down": "Siirry luettelossa eteenpäin",
  "keyboard_shortcuts.enter": "Avaa julkaisu",
  "keyboard_shortcuts.explore": "Avaa Suosittua-aikajana",
  "keyboard_shortcuts.favourite": "Lisää julkaisu suosikkeihin",
  "keyboard_shortcuts.favourites": "Avaa suosikkiluettelo",
  "keyboard_shortcuts.federated": "Avaa yleinen aikajana",
  "keyboard_shortcuts.heading": "Pikanäppäimet",
  "keyboard_shortcuts.home": "Avaa kotiaikajana",
  "keyboard_shortcuts.hotkey": "Pikanäppäin",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Askelpalautin",
  "keyboard_shortcuts.keys.enter": "Enter",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Page Down",
  "keyboard_shortcuts.keys.page_up": "Page Up",
  "keyboard_shortcuts.legend": "Näytä tämä ohje",
  "keyboard_shortcuts.load_more": "Kohdista ”Lataa lisää” -⁠painikkeeseen",
  "keyboard_shortcuts.local": "Avaa paikallinen aikajana",
  "keyboard_shortcuts.mention": "Mainitse tekijä",
  "keyboard_shortcuts.muted": "Avaa mykistettyjen käyttäjien luettelo",
  "keyboard_shortcuts.my_profile": "Avaa profiilisi",
  "keyboard_shortcuts.notifications": "Avaa ilmoitussarake",
  "keyboard_shortcuts.open_media": "Avaa media",
  "keyboard_shortcuts.pinned": "Avaa kiinnitettyjen julkaisujen luettelo",
  "keyboard_shortcuts.profile": "Avaa tekijän profiili",
  "keyboard_shortcuts.quote": "Lainaa julkaisua",
  "keyboard_shortcuts.reply": "Vastaa julkaisuun",
  "keyboard_shortcuts.requests": "Avaa seurantapyyntöjen luettelo",
  "keyboard_shortcuts.search": "Kohdista hakukenttään",
  "keyboard_shortcuts.spoilers": "Näytä tai piilota sisältövaroituskenttä",
  "keyboard_shortcuts.start": "Avaa ”Näin pääset alkuun” -⁠sarake",
  "keyboard_shortcuts.toggle_hidden": "Näytä tai piilota sisältövaroituksella merkitty teksti",
  "keyboard_shortcuts.toggle_sensitivity": "Näytä tai piilota media",
  "keyboard_shortcuts.toot": "Luo uusi julkaisu",
  "keyboard_shortcuts.top": "Siirry luettelon alkuun",
  "keyboard_shortcuts.translate": "Käännä julkaisu",
  "keyboard_shortcuts.unfocus": "Poistu laadinta- tai hakukentästä",
  "keyboard_shortcuts.up": "Siirry luettelossa taaksepäin",
  "learn_more_link.got_it": "Selvä",
  "learn_more_link.learn_more": "Lue lisää",
  "lightbox.close": "Sulje",
  "lightbox.next": "Seuraava",
  "lightbox.previous": "Edellinen",
  "lightbox.zoom_in": "Näytä todellisen kokoisena",
  "lightbox.zoom_out": "Näytä sovitettuna",
  "limited_account_hint.action": "Näytä profiili kuitenkin",
  "limited_account_hint.title": "Palvelimen {domain} moderaattorit ovat piilottaneet tämän profiilin.",
  "link_preview.author": "Tehnyt {name}",
  "link_preview.more_from_author": "Lisää tekijältä {name}",
  "link_preview.shares": "{count, plural, one {{counter} julkaisu} other {{counter} julkaisua}}",
  "lists.add_member": "Lisää",
  "lists.add_to_list": "Lisää listaan",
  "lists.add_to_lists": "Lisää {name} listaan",
  "lists.create": "Luo",
  "lists.create_a_list_to_organize": "Luo uusi lista kotisyötteesi järjestämiseksi",
  "lists.create_list": "Luo lista",
  "lists.delete": "Poista lista",
  "lists.done": "Valmis",
  "lists.edit": "Muokkaa listaa",
  "lists.exclusive": "Piilota jäsenet kotisyötteestä",
  "lists.exclusive_hint": "Jos joku on tässä listassa, piilota hänet kotisyötteestäsi, jotta et näe hänen julkaisujaan kahteen kertaan.",
  "lists.find_users_to_add": "Etsi lisättäviä käyttäjiä",
  "lists.list_members_count": "{count, plural, one {# jäsen} other {# jäsentä}}",
  "lists.list_name": "Listan nimi",
  "lists.new_list_name": "Uuden listan nimi",
  "lists.no_lists_yet": "Ei vielä listoja.",
  "lists.no_members_yet": "Ei vielä jäseniä.",
  "lists.no_results_found": "Tuloksia ei löytynyt.",
  "lists.remove_member": "Poista",
  "lists.replies_policy.followed": "Jokaiselle seurattavalle käyttäjälle",
  "lists.replies_policy.list": "Listan jäsenille",
  "lists.replies_policy.none": "Ei kellekään",
  "lists.save": "Tallenna",
  "lists.search": "Haku",
  "lists.show_replies_to": "Sisällytä listan jäsenten vastaukset kohteeseen",
  "load_pending": "{count, plural, one {# uusi kohde} other {# uutta kohdetta}}",
  "loading_indicator.label": "Ladataan…",
  "media_gallery.hide": "Piilota",
  "moved_to_account_banner.text": "Tilisi {disabledAccount} on tällä hetkellä poissa käytöstä, koska teit siirron tiliin {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Piilota ilmoituksista",
  "mute_modal.hide_options": "Piilota vaihtoehdot",
  "mute_modal.indefinite": "Kunnes kumoan häntä koskevan mykistyksen",
  "mute_modal.show_options": "Näytä vaihtoehdot",
  "mute_modal.they_can_mention_and_follow": "Hän voi mainita sinut ja seurata sinua, mutta sinä et näe häntä.",
  "mute_modal.they_wont_know": "Hän ei saa tietää tulleensa mykistetyksi.",
  "mute_modal.title": "Mykistetäänkö käyttäjä?",
  "mute_modal.you_wont_see_mentions": "Et näe enää julkaisuja, joissa hänet mainitaan.",
  "mute_modal.you_wont_see_posts": "Hän voi yhä nähdä julkaisusi, mutta sinä et näe hänen.",
  "navigation_bar.about": "Tietoja",
  "navigation_bar.account_settings": "Salasana ja turvallisuus",
  "navigation_bar.administration": "Ylläpito",
  "navigation_bar.advanced_interface": "Avaa edistyneessä selainkäyttöliittymässä",
  "navigation_bar.automated_deletion": "Julkaisujen automaattipoisto",
  "navigation_bar.blocks": "Estetyt käyttäjät",
  "navigation_bar.bookmarks": "Kirjanmerkit",
  "navigation_bar.collections": "Kokoelmat",
  "navigation_bar.direct": "Yksityismaininnat",
  "navigation_bar.domain_blocks": "Estetyt verkkotunnukset",
  "navigation_bar.favourites": "Suosikit",
  "navigation_bar.filters": "Mykistetyt sanat",
  "navigation_bar.follow_requests": "Seurantapyynnöt",
  "navigation_bar.followed_tags": "Seurattavat aihetunnisteet",
  "navigation_bar.follows_and_followers": "Seurattavat ja seuraajat",
  "navigation_bar.import_export": "Tuo ja vie",
  "navigation_bar.lists": "Listat",
  "navigation_bar.live_feed_local": "Livesyöte (paikallinen)",
  "navigation_bar.live_feed_public": "Livesyöte (julkinen)",
  "navigation_bar.logout": "Kirjaudu ulos",
  "navigation_bar.main": "Pääosio",
  "navigation_bar.moderation": "Moderointi",
  "navigation_bar.more": "Lisää",
  "navigation_bar.mutes": "Mykistetyt käyttäjät",
  "navigation_bar.opened_in_classic_interface": "Julkaisut, profiilit ja tietyt muut sivut avautuvat oletuksena perinteiseen selainkäyttöliittymään.",
  "navigation_bar.preferences": "Asetukset",
  "navigation_bar.privacy_and_reach": "Yksityisyys ja tavoittavuus",
  "navigation_bar.search": "Haku",
  "navigation_bar.search_trends": "Haku / Suosittua",
  "navigation_panel.collapse_followed_tags": "Supista seurattavien aihetunnisteiden valikko",
  "navigation_panel.collapse_lists": "Supista listavalikko",
  "navigation_panel.expand_followed_tags": "Laajenna seurattavien aihetunnisteiden valikko",
  "navigation_panel.expand_lists": "Laajenna listavalikko",
  "not_signed_in_indicator.not_signed_in": "Sinun on kirjauduttava sisään käyttääksesi resurssia.",
  "notification.added_to_collection": "{name} lisäsi sinut kokoelmaan",
  "notification.admin.report": "{name} raportoi käyttäjän {target}",
  "notification.admin.report_account": "{name} raportoi {count, plural, one {julkaisun} other {# julkaisua}} käyttäjältä {target}, syynä {category}",
  "notification.admin.report_account_other": "{name} raportoi {count, plural, one {julkaisun} other {# julkaisua}} käyttäjältä {target}",
  "notification.admin.report_statuses": "{name} raportoi käyttäjän {target}, syynä {category}",
  "notification.admin.report_statuses_other": "{name} raportoi käyttäjän {target}",
  "notification.admin.sign_up": "{name} rekisteröityi",
  "notification.admin.sign_up.name_and_others": "{name} ja {count, plural, one {# muu} other {# muuta}} rekisteröityivät",
  "notification.annual_report.message": "Vuoden {year} #Wrapstodon odottaa! Paljasta vuotesi kohokohdat ikimuistoiset hetket Mastodonissa!",
  "notification.annual_report.view": "Näytä #Wrapstodon",
  "notification.collection_update": "{name} muokkasi kokoelmaa, jossa olet",
  "notification.favourite": "{name} lisäsi julkaisusi suosikkeihinsa",
  "notification.favourite.name_and_others_with_link": "{name} ja <a>{count, plural, one {# muu} other {# muuta}}</a> lisäsivät julkaisusi suosikkeihinsa",
  "notification.favourite_pm": "{name} lisäsi yksityismainintasi suosikkeihinsa",
  "notification.favourite_pm.name_and_others_with_link": "{name} ja <a>{count, plural, one {# muu} other {# muuta}}</a> lisäsivät yksityismainintasi suosikkeihinsa",
  "notification.follow": "{name} seurasi sinua",
  "notification.follow.name_and_others": "{name} ja <a>{count, plural, one {# muu} other {# muuta}}</a> seurasivat sinua",
  "notification.follow_request": "{name} on pyytänyt lupaa seurata sinua",
  "notification.follow_request.name_and_others": "{name} ja {count, plural, one {# muu} other {# muuta}} pyysivät saada seurata sinua",
  "notification.label.mention": "Maininta",
  "notification.label.private_mention": "Yksityismaininta",
  "notification.label.private_reply": "Yksityinen vastaus",
  "notification.label.quote": "{name} lainasi julkaisuasi",
  "notification.label.reply": "Vastaus",
  "notification.mention": "Maininta",
  "notification.mentioned_you": "{name} mainitsi sinut",
  "notification.moderation-warning.learn_more": "Lue lisää",
  "notification.moderation_warning": "Olet saanut moderointivaroituksen",
  "notification.moderation_warning.action_delete_statuses": "Julkaisujasi on poistettu.",
  "notification.moderation_warning.action_disable": "Tilisi on poistettu käytöstä.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Julkaisujasi on merkitty arkaluonteisiksi.",
  "notification.moderation_warning.action_none": "Tilisi on saanut moderointivaroituksen.",
  "notification.moderation_warning.action_sensitive": "Tästä lähtien julkaisusi merkitään arkaluonteisiksi.",
  "notification.moderation_warning.action_silence": "Tiliäsi on rajoitettu.",
  "notification.moderation_warning.action_suspend": "Tilisi on jäädytetty.",
  "notification.own_poll": "Äänestyksesi on päättynyt",
  "notification.poll": "Äänestys, johon osallistuit, on päättynyt",
  "notification.quoted_update": "{name} muokkasi lainaamaasi julkaisua",
  "notification.reblog": "{name} tehosti julkaisuasi",
  "notification.reblog.name_and_others_with_link": "{name} ja <a>{count, plural, one {# muu} other {# muuta}}</a> tehostivat julkaisuasi",
  "notification.relationships_severance_event": "Menetettiin yhteydet palvelimeen {name}",
  "notification.relationships_severance_event.account_suspension": "Palvelimen {from} ylläpitäjä on jäädyttänyt palvelimen {target} vuorovaikutuksen. Enää et voi siis vastaanottaa päivityksiä heiltä tai olla yhteyksissä heidän kanssaan.",
  "notification.relationships_severance_event.domain_block": "Palvelimen {from} ylläpitäjä on estänyt palvelimen {target} vuorovaikutuksen – mukaan lukien {followersCount} seuraajistasi ja {followingCount, plural, one {# seurattavistasi} other {# seurattavistasi}}.",
  "notification.relationships_severance_event.learn_more": "Lue lisää",
  "notification.relationships_severance_event.user_domain_block": "Olet estänyt palvelimen {target}, mikä poisti {followersCount} seuraajistasi ja {followingCount, plural, one {# seurattavistasi} other {# seurattavistasi}}.",
  "notification.status": "{name} julkaisi juuri",
  "notification.update": "{name} muokkasi julkaisua",
  "notification_requests.accept": "Hyväksy",
  "notification_requests.accept_multiple": "{count, plural, one {Hyväksy # pyyntö…} other {Hyväksy # pyyntöä…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Hyväksy pyyntö} other {Hyväksy pyynnöt}}",
  "notification_requests.confirm_accept_multiple.message": "Olet aikeissa hyväksyä {count, plural, one {ilmoituspyynnön} other {# ilmoituspyyntöä}}. Haluatko varmasti jatkaa?",
  "notification_requests.confirm_accept_multiple.title": "Hyväksytäänkö ilmoituspyynnöt?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Hylkää pyyntö} other {Hylkää pyynnöt}}",
  "notification_requests.confirm_dismiss_multiple.message": "Olet aikeissa hylätä {count, plural, one {ilmoituspyynnön} other {# ilmoituspyyntöä}}. Et saa {count, plural, one {sitä} other {niitä}} enää helposti takaisin. Haluatko varmasti jatkaa?",
  "notification_requests.confirm_dismiss_multiple.title": "Hylätäänkö ilmoituspyynnöt?",
  "notification_requests.dismiss": "Hylkää",
  "notification_requests.dismiss_multiple": "{count, plural, one {Hylkää # pyyntö…} other {Hylkää # pyyntöä…}}",
  "notification_requests.edit_selection": "Muokkaa",
  "notification_requests.exit_selection": "Valmis",
  "notification_requests.explainer_for_limited_account": "Tähän tiliin liittyvät ilmoitukset on suodatettu, koska moderaattori on rajoittanut tiliä.",
  "notification_requests.explainer_for_limited_remote_account": "Tähän tiliin liittyvät ilmoitukset on suodatettu, koska moderaattori on rajoittanut tiliä tai sen palvelinta.",
  "notification_requests.maximize": "Suurenna",
  "notification_requests.minimize_banner": "Pienennä suodatettujen ilmoitusten palkki",
  "notification_requests.notifications_from": "Ilmoitukset käyttäjältä {name}",
  "notification_requests.title": "Suodatetut ilmoitukset",
  "notification_requests.view": "Näytä ilmoitukset",
  "notifications.clear": "Tyhjennä ilmoitukset",
  "notifications.clear_confirmation": "Haluatko varmasti poistaa kaikki ilmoitukset pysyvästi?",
  "notifications.clear_title": "Tyhjennetäänkö ilmoitukset?",
  "notifications.column_settings.admin.report": "Uudet raportit:",
  "notifications.column_settings.admin.sign_up": "Uudet rekisteröitymiset:",
  "notifications.column_settings.alert": "Työpöytäilmoitukset",
  "notifications.column_settings.collections": "Kokoelmat:",
  "notifications.column_settings.favourite": "Suosikit:",
  "notifications.column_settings.filter_bar.advanced": "Näytä kaikki luokat",
  "notifications.column_settings.filter_bar.category": "Pikasuodatuspalkki",
  "notifications.column_settings.follow": "Uudet seuraajat:",
  "notifications.column_settings.follow_request": "Uudet seurantapyynnöt:",
  "notifications.column_settings.group": "Ryhmitä",
  "notifications.column_settings.mention": "Maininnat:",
  "notifications.column_settings.poll": "Äänestystulokset:",
  "notifications.column_settings.push": "Puskuilmoitukset",
  "notifications.column_settings.quote": "Lainaukset:",
  "notifications.column_settings.reblog": "Tehostukset:",
  "notifications.column_settings.show": "Näytä sarakkeessa",
  "notifications.column_settings.sound": "Äänimerkki",
  "notifications.column_settings.status": "Uudet julkaisut:",
  "notifications.column_settings.unread_notifications.category": "Lukemattomat ilmoitukset",
  "notifications.column_settings.unread_notifications.highlight": "Korosta lukemattomat ilmoitukset",
  "notifications.column_settings.update": "Muokkaukset:",
  "notifications.filter.all": "Kaikki",
  "notifications.filter.boosts": "Tehostukset",
  "notifications.filter.collections": "Kokoelmat",
  "notifications.filter.favourites": "Suosikit",
  "notifications.filter.follows": "Seuraamiset",
  "notifications.filter.mentions": "Maininnat",
  "notifications.filter.polls": "Äänestystulokset",
  "notifications.filter.statuses": "Päivitykset seuraamiltasi käyttäjiltä",
  "notifications.grant_permission": "Myönnä käyttöoikeus.",
  "notifications.group": "{count} ilmoitusta",
  "notifications.mark_as_read": "Merkitse jokainen ilmoitus luetuksi",
  "notifications.permission_denied": "Työpöytäilmoitukset eivät ole käytettävissä, koska selaimen käyttöoikeuspyyntö on aiemmin evätty",
  "notifications.permission_denied_alert": "Työpöytäilmoituksia ei voi ottaa käyttöön, koska selaimen käyttöoikeus on aiemmin evätty",
  "notifications.permission_required": "Työpöytäilmoitukset eivät ole käytettävissä, koska siihen tarvittavaa käyttöoikeutta ei ole myönnetty.",
  "notifications.policy.accept": "Hyväksy",
  "notifications.policy.accept_hint": "Näytä ilmoituksissa",
  "notifications.policy.drop": "Sivuuta",
  "notifications.policy.drop_hint": "Lähetä tyhjyyteen, jotta et näe niitä enää koskaan",
  "notifications.policy.filter": "Suodata",
  "notifications.policy.filter_bots_hint": "Automatisoiduiksi merkityt tilit",
  "notifications.policy.filter_bots_title": "Botit",
  "notifications.policy.filter_hint": "Lähetä suodatettuihin ilmoituksiin",
  "notifications.policy.filter_limited_accounts_hint": "Palvelimen moderaattorien rajoittamat",
  "notifications.policy.filter_limited_accounts_title": "Moderoidut tilit",
  "notifications.policy.filter_new_accounts.hint": "Luotu {days, plural, one {viime päivän} other {viimeisen # päivän}} aikana",
  "notifications.policy.filter_new_accounts_title": "Uudet tilit",
  "notifications.policy.filter_not_followers_hint": "Mukaan lukien alle {days, plural, one {päivän} other {# päivää}} sinua seuranneet",
  "notifications.policy.filter_not_followers_title": "Käyttäjät, jotka eivät seuraa sinua",
  "notifications.policy.filter_not_following_hint": "Kunnes hyväksyt heidät manuaalisesti",
  "notifications.policy.filter_not_following_title": "Käyttäjät, joita et seuraa",
  "notifications.policy.filter_private_mentions_hint": "Suodatetaan, ellei se ole vastaus omaan mainintaasi tai ellet seuraa lähettäjää",
  "notifications.policy.filter_private_mentions_title": "Pyytämättömät yksityismaininnat",
  "notifications.policy.title": "Hallitse ilmoituksia kohteesta…",
  "notifications_permission_banner.enable": "Ota työpöytäilmoitukset käyttöön",
  "notifications_permission_banner.how_to_control": "Saadaksesi ilmoituksia, kun Mastodon ei ole auki, ota työpöytäilmoitukset käyttöön. Voit hallita tarkasti, mistä saat työpöytäilmoituksia kun ilmoitukset on otettu käyttöön yllä olevan {icon}-painikkeen kautta.",
  "notifications_permission_banner.title": "Älä anna minkään mennä ohi",
  "onboarding.follows.back": "Takaisin",
  "onboarding.follows.empty": "Valitettavasti tuloksia ei voida näyttää juuri nyt. Voit kokeilla hakua tai selata tutustumissivua löytääksesi seurattavaa tai yrittää myöhemmin uudelleen.",
  "onboarding.follows.next": "Seuraavaksi: määrittele profiilisi",
  "onboarding.follows.search": "Haku",
  "onboarding.follows.title": "Aloita seuraamalla käyttäjiä",
  "onboarding.profile.discoverable": "Aseta profiilini löydettäväksi",
  "onboarding.profile.discoverable_hint": "Kun olet määrittänyt itsesi löydettäväksi Mastodonista, julkaisusi voivat näkyä hakutuloksissa ja suosituissa kohteissa. Lisäksi profiiliasi voidaan ehdottaa käyttäjille, jotka ovat kiinnostuneita kanssasi samoista aiheista.",
  "onboarding.profile.display_name": "Näyttönimi",
  "onboarding.profile.display_name_hint": "Koko nimesi tai lempinimesi…",
  "onboarding.profile.finish": "Valmis",
  "onboarding.profile.note": "Elämäkerta",
  "onboarding.profile.note_hint": "Voit @mainita muita käyttäjiä tai #aihetunnisteita…",
  "onboarding.profile.title": "Profiilin määritys",
  "onboarding.profile.upload_avatar": "Lähetä profiilikuva",
  "onboarding.profile.upload_header": "Lähetä profiilin otsakekuva",
  "password_confirmation.exceeds_maxlength": "Salasanan vahvistus ylittää salasanan enimmäispituuden",
  "password_confirmation.mismatching": "Salasanan vahvistus ei täsmää",
  "picture_in_picture.restore": "Laita se takaisin",
  "poll.closed": "Päättynyt",
  "poll.refresh": "Päivitä",
  "poll.reveal": "Näytä tulokset",
  "poll.total_people": "{count, plural, one {# käyttäjä} other {# käyttäjää}}",
  "poll.total_votes": "{count, plural, one {# ääni} other {# ääntä}}",
  "poll.vote": "Äänestä",
  "poll.voted": "Äänestit tätä vastausta",
  "poll.votes": "{votes, plural, one {# ääni} other {# ääntä}}",
  "poll_button.add_poll": "Lisää äänestys",
  "poll_button.remove_poll": "Poista äänestys",
  "privacy.change": "Muuta julkaisun näkyvyyttä",
  "privacy.direct.long": "Kaikki tässä julkaisussa mainitut",
  "privacy.direct.short": "Yksityismaininta",
  "privacy.private.long": "Vain seuraajasi",
  "privacy.private.short": "Seuraajat",
  "privacy.public.long": "Kuka tahansa Mastodonissa ja sen ulkopuolella",
  "privacy.public.short": "Julkinen",
  "privacy.quote.anyone": "{visibility}, lainaukset sallittu",
  "privacy.quote.disabled": "{visibility}, lainaukset poissa käytöstä",
  "privacy.quote.limited": "{visibility}, lainauksia rajoitettu",
  "privacy.unlisted.additional": "Tämä toimii muuten kuin julkinen, mutta julkaisut eivät näy livesyöte-, aihetunniste- tai selausnäkymissä eivätkä Mastodonin hakutuloksissa, vaikka ne olisivat käyttäjätililläsi yleisesti sallittuina.",
  "privacy.unlisted.long": "Piilotettu Mastodonin hakutuloksista, trendeistä ja julkisilta aikajanoilta",
  "privacy.unlisted.short": "Vaivihkaa julkinen",
  "privacy_policy.last_updated": "Päivitetty viimeksi {date}",
  "privacy_policy.title": "Tietosuojakäytäntö",
  "quote_error.edit": "Lainauksia ei voi lisätä julkaisua muokattaessa.",
  "quote_error.poll": "Lainaaminen äänestyksen ohessa ei ole sallittua.",
  "quote_error.private_mentions": "Lainaaminen ei ole sallittua yksityismaininnoissa.",
  "quote_error.quote": "Vain yksi lainaus kerrallaan on sallittu.",
  "quote_error.unauthorized": "Sinulla ei ole valtuuksia lainata tätä julkaisua.",
  "quote_error.upload": "Medialiitteiden lainaaminen ei ole sallittua.",
  "recommended": "Suositellaan",
  "refresh": "Päivitä",
  "regeneration_indicator.please_stand_by": "Ole valmiina.",
  "regeneration_indicator.preparing_your_home_feed": "Kotisyötettäsi valmistellaan…",
  "relative_time.days": "{number} pv",
  "relative_time.full.days": "{number, plural, one {# päivä} other {# päivää}} sitten",
  "relative_time.full.hours": "{number, plural, one {# tunti} other {# tuntia}} sitten",
  "relative_time.full.just_now": "juuri nyt",
  "relative_time.full.minutes": "{number, plural, one {# minuutti} other {# minuuttia}} sitten",
  "relative_time.full.seconds": "{number, plural, one {# sekunti} other {# sekuntia}} sitten",
  "relative_time.hours": "{number} t",
  "relative_time.just_now": "nyt",
  "relative_time.minutes": "{number} min",
  "relative_time.seconds": "{number} s",
  "relative_time.today": "tänään",
  "remove_quote_hint.button_label": "Selvä",
  "remove_quote_hint.message": "Voit tehdä sen {icon}-valikosta.",
  "remove_quote_hint.title": "Haluatko poistaa lainatun julkaisusi?",
  "reply_indicator.attachments": "{count, plural, one {# liite} other {# liitettä}}",
  "reply_indicator.cancel": "Peruuta",
  "reply_indicator.poll": "Äänestys",
  "report.block": "Estä",
  "report.block_explanation": "Et näe hänen julkaisujaan. Hän ei voi nähdä julkaisujasi eikä seurata sinua. Hän näkee, että olet estänyt hänet.",
  "report.categories.legal": "Lakiseikat",
  "report.categories.other": "Muu",
  "report.categories.spam": "Roskaposti",
  "report.categories.violation": "Sisältö rikkoo yhtä tai useampaa palvelimen säännöistä",
  "report.category.subtitle": "Valitse sopivin",
  "report.category.title_account": "Kerro meille, mitä tässä profiilissa on meneillään",
  "report.category.title_collection": "Kerro meille, mitä tässä kokoelmassa on meneillään",
  "report.category.title_status": "Kerro meille, mitä tässä julkaisussa on meneillään",
  "report.close": "Valmis",
  "report.comment.title": "Onko vielä jotain muuta, mitä meidän pitäisi tietää?",
  "report.forward": "Välitä palvelimelle {target}",
  "report.forward_hint": "Tämä tili on toisella palvelimella. Haluatko lähettää nimettömän raportin myös sinne?",
  "report.mute": "Mykistä",
  "report.mute_explanation": "Et näe hänen julkaisujaan. Hän voi silti seurata sinua ja nähdä julkaisusi. Hän ei tiedä, että hänet on mykistetty.",
  "report.next": "Seuraava",
  "report.placeholder": "Lisäkommentit",
  "report.reasons.dislike": "En pidä siitä",
  "report.reasons.dislike_description": "Sisältö on sellaista, jota et halua nähdä",
  "report.reasons.legal": "Se on laitonta",
  "report.reasons.legal_description": "Katsot sisällön rikkovan maasi tai palvelimen kotimaan lakeja",
  "report.reasons.other": "Jotain muuta",
  "report.reasons.other_description": "Muut raportointisyyt eivät kuvaa ongelmaa",
  "report.reasons.spam": "Se on roskapostia",
  "report.reasons.spam_description": "Haitalliset linkit, henkilöväärennökset tai itseään toistavat vastaukset",
  "report.reasons.violation": "Se rikkoo palvelimen sääntöjä",
  "report.reasons.violation_description": "Tiedät sisällön rikkovan tiettyjä sääntöjä",
  "report.rules.subtitle": "Valitse kaikki sopivat",
  "report.rules.title": "Mitä sääntöjä rikotaan?",
  "report.statuses.subtitle": "Valitse kaikki sopivat",
  "report.statuses.title": "Onko julkaisuja, jotka tukevat tätä raporttia?",
  "report.submission_error": "Raporttia ei voitu lähettää",
  "report.submission_error_details": "Tarkista verkkoyhteytesi ja yritä uudelleen myöhemmin.",
  "report.submit": "Lähetä",
  "report.target": "Raportoidaan {target}",
  "report.thanks.take_action": "Tässä on vaihtoehtosi hallita näkemääsi Mastodonissa:",
  "report.thanks.take_action_actionable": "Sillä välin kun tarkistamme tätä, voit ryhtyä toimiin käyttäjää @{name} kohtaan:",
  "report.thanks.title": "Etkö halua nähdä tätä?",
  "report.thanks.title_actionable": "Kiitos raportista – tutkimme asiaa.",
  "report.unfollow": "Lopeta käyttäjän @{name} seuraaminen",
  "report.unfollow_explanation": "Seuraat tätä tiliä. Jotta et enää näkisi sen julkaisuja kotisyötteessäsi, lopeta tilin seuraaminen.",
  "report_notification.attached_statuses": "{count, plural, one {{count} julkaisu} other {{count} julkaisua}} liitteenä",
  "report_notification.categories.legal": "Lakiseikat",
  "report_notification.categories.legal_sentence": "laiton sisältö",
  "report_notification.categories.other": "Muu",
  "report_notification.categories.other_sentence": "jokin muu",
  "report_notification.categories.spam": "Roskaposti",
  "report_notification.categories.spam_sentence": "roskaposti",
  "report_notification.categories.violation": "Sääntörikkomus",
  "report_notification.categories.violation_sentence": "sääntörikkomus",
  "report_notification.open": "Avaa raportti",
  "search.clear": "Tyhjennä haku",
  "search.no_recent_searches": "Ei viimeaikaisia hakuja",
  "search.placeholder": "Hae",
  "search.quick_action.account_search": "Profiilit haulla {x}",
  "search.quick_action.go_to_account": "Siirry profiiliin {x}",
  "search.quick_action.go_to_hashtag": "Siirry aihetunnisteeseen {x}",
  "search.quick_action.open_url": "Avaa URL-⁠osoite Mastodonissa",
  "search.quick_action.status_search": "Julkaisut haulla {x}",
  "search.search_or_paste": "Hae tai liitä URL-⁠osoite",
  "search_popout.full_text_search_disabled_message": "Ei saatavilla palvelimella {domain}.",
  "search_popout.full_text_search_logged_out_message": "Saatavilla vain sisäänkirjautuneena.",
  "search_popout.language_code": "ISO-kielikoodi",
  "search_popout.options": "Hakuvalinnat",
  "search_popout.quick_actions": "Pikatoiminnot",
  "search_popout.recent": "Viimeaikaiset haut",
  "search_popout.specific_date": "tietty päivämäärä",
  "search_popout.user": "käyttäjä",
  "search_results.accounts": "Profiilit",
  "search_results.all": "Kaikki",
  "search_results.collections": "Kokoelmat",
  "search_results.hashtags": "Aihetunnisteet",
  "search_results.no_results": "Ei tuloksia.",
  "search_results.no_search_yet": "Kokeile hakea julkaisuja, profiileja tai aihetunnisteita.",
  "search_results.see_all": "Näytä kaikki",
  "search_results.statuses": "Julkaisut",
  "search_results.title": "Haku ”{q}”",
  "server_banner.about_active_users": "Palvelimen käyttäjät viimeisten 30 päivän ajalta (kuukauden aktiiviset käyttäjät)",
  "server_banner.active_users": "aktiivista käyttäjää",
  "server_banner.administered_by": "Ylläpitäjä:",
  "server_banner.is_one_of_many": "{domain} on yksi monista itsenäisistä Mastodon-palvelimista, joiden välityksellä voit toimia fediversumissa.",
  "server_banner.more_about_this_server": "Lisää tästä palvelimesta",
  "server_banner.server_stats": "Palvelimen tilastot:",
  "sign_in_banner.create_account": "Luo tili",
  "sign_in_banner.follow_anyone": "Seuraa kenen tahansa julkaisuja fediversumissa ja näe ne kaikki aikajärjestyksessä. Ei algoritmeja, mainoksia eikä klikkausten kalastelua.",
  "sign_in_banner.mastodon_is": "Mastodon on paras tapa pysyä ajan tasalla siitä, mitä ympärillä tapahtuu.",
  "sign_in_banner.sign_in": "Kirjaudu",
  "sign_in_banner.sso_redirect": "Kirjaudu tai rekisteröidy",
  "skip_links.hotkey": "<span>Pikanäppäin</span> {hotkey}",
  "skip_links.skip_to_content": "Siirry pääsisältöön",
  "skip_links.skip_to_navigation": "Siirry päänavigaatioon",
  "status.admin_account": "Avaa tilin @{name} moderointinäkymä",
  "status.admin_domain": "Avaa palvelimen {domain} moderointinäkymä",
  "status.admin_status": "Avaa julkaisu moderointinäkymässä",
  "status.all_disabled": "Tehostukset ja lainaukset ovat poissa käytöstä",
  "status.block": "Estä @{name}",
  "status.bookmark": "Lisää kirjanmerkki",
  "status.cancel_reblog_private": "Peru tehostus",
  "status.cannot_edit": "Sinulla ei ole oikeutta muokata tätä julkaisua",
  "status.cannot_quote": "Sinulla ei ole oikeutta lainata tätä julkaisua",
  "status.cannot_reblog": "Tätä julkaisua ei voi tehostaa",
  "status.contains_quote": "Sisältää lainauksen",
  "status.context.loading": "Ladataan lisää vastauksia",
  "status.context.loading_error": "Ei voitu ladata lisää vastauksia",
  "status.context.loading_success": "Uudet vastaukset ladattu",
  "status.context.more_replies_found": "Löytyi lisää vastauksia",
  "status.context.retry": "Yritä uudelleen",
  "status.context.show": "Näytä",
  "status.continued_thread": "Jatkoi ketjua",
  "status.copy": "Kopioi linkki julkaisuun",
  "status.delete": "Poista",
  "status.delete.success": "Julkaisu poistettu",
  "status.detailed_status": "Yksityiskohtainen keskustelunäkymä",
  "status.direct": "Mainitse @{name} yksityisesti",
  "status.direct_indicator": "Yksityismaininta",
  "status.edit": "Muokkaa",
  "status.edited": "Viimeksi muokattu {date}",
  "status.edited_x_times": "Muokattu {count, plural, one {{count} kerran} other {{count} kertaa}}",
  "status.embed": "Hanki upotuskoodi",
  "status.favourite": "Suosikki",
  "status.favourites_count": "{count, plural, one {{counter} suosikki} other {{counter} suosikkia}}",
  "status.filter": "Suodata tämä julkaisu",
  "status.history.created": "{name} loi {date}",
  "status.history.edited": "{name} muokkasi {date}",
  "status.load_more": "Lataa lisää",
  "status.media.open": "Avaa napsauttamalla",
  "status.media.show": "Näytä napsauttamalla",
  "status.media_hidden": "Media piilotettu",
  "status.mention": "Mainitse @{name}",
  "status.more": "Enemmän",
  "status.mute": "Mykistä @{name}",
  "status.mute_conversation": "Mykistä keskustelu",
  "status.not_quoted": "Sinua ei lainata tässä julkaisussa",
  "status.open": "Laajenna julkaisu",
  "status.pin": "Kiinnitä profiiliin",
  "status.public_only": "Tämä julkaisu on yksityinen",
  "status.quote": "Lainaa",
  "status.quote.cancel": "Peruuta lainaus",
  "status.quote_error.blocked_account_hint.title": "Tämä julkaisu on piilotettu, koska olet estänyt käyttäjän @{name}.",
  "status.quote_error.blocked_domain_hint.title": "Tämä julkaisu on piilotettu, koska olet estänyt verkkotunnuksen {domain}.",
  "status.quote_error.filtered": "Piilotettu jonkin asettamasi suodattimen takia",
  "status.quote_error.limited_account_hint.action": "Näytä kuitenkin",
  "status.quote_error.limited_account_hint.title": "Palvelimen {domain} moderaattorit ovat piilottaneet tämän profiilin.",
  "status.quote_error.muted_account_hint.title": "Tämä julkaisu on piilotettu, koska olet mykistänyt käyttäjän @{name}.",
  "status.quote_error.not_available": "Julkaisu ei saatavilla",
  "status.quote_error.pending_approval": "Julkaisu odottaa",
  "status.quote_error.pending_approval_popout.body": "Mastodonissa voit hallita, voiko joku lainata sinua. Tämä julkaisu on vireillä siihen asti, että saamme alkuperäisen tekijän hyväksynnän.",
  "status.quote_error.revoked": "Tekijä on poistanut julkaisun",
  "status.quote_followers_only": "Vain seuraajat voivat lainata tätä julkaisua",
  "status.quote_manual_review": "Tekijä arvioi pyynnön manuaalisesti",
  "status.quote_noun": "Lainaus",
  "status.quote_policy_change": "Vaihda, kuka voi lainata",
  "status.quote_post_author": "Lainaa käyttäjän @{name} julkaisua",
  "status.quote_private": "Yksityisiä julkaisuja ei voi lainata",
  "status.quotes.empty": "Kukaan ei ole vielä lainannut tätä julkaisua. Kun joku tekee niin, se tulee tähän näkyviin.",
  "status.quotes.local_other_disclaimer": "Tekijän hylkäämiä lainauksia ei näytetä.",
  "status.quotes.remote_other_disclaimer": "Vain palvelimen {domain} lainaukset näkyvät taatusti tässä. Tekijän hylkäämiä lainauksia ei näytetä.",
  "status.quotes_count": "{count, plural, one {{counter} lainaus} other {{counter} lainausta}}",
  "status.read_more": "Näytä enemmän",
  "status.reblog": "Tehosta",
  "status.reblog_or_quote": "Tehosta tai lainaa",
  "status.reblog_private": "Jaa uudelleen seuraajiesi kanssa",
  "status.reblogged_by": "{name} tehosti",
  "status.reblogs.empty": "Kukaan ei ole vielä tehostanut tätä julkaisua. Kun joku tekee niin, hän tulee tähän näkyviin.",
  "status.reblogs_count": "{count, plural, one {{counter} tehostus} other {{counter} tehostusta}}",
  "status.redraft": "Poista ja palauta muokattavaksi",
  "status.remove_bookmark": "Poista kirjanmerkki",
  "status.remove_favourite": "Poista suosikeista",
  "status.remove_quote": "Poista",
  "status.replied_in_thread": "Vastasi ketjuun",
  "status.replied_to": "Vastaus käyttäjälle {name}",
  "status.reply": "Vastaa",
  "status.replyAll": "Vastaa ketjuun",
  "status.report": "Raportoi @{name}",
  "status.request_quote": "Pyydä lupaa lainata",
  "status.revoke_quote": "Poista julkaisuni käyttäjän @{name} julkaisusta",
  "status.sensitive_warning": "Arkaluonteista sisältöä",
  "status.share": "Jaa",
  "status.show_less_all": "Näytä kaikista vähemmän",
  "status.show_more_all": "Näytä kaikista enemmän",
  "status.show_original": "Näytä alkuperäinen",
  "status.title.with_attachments": "{user} julkaisi {attachmentCount, plural, one {liitteen} other {{attachmentCount} liitettä}}",
  "status.translate": "Käännä",
  "status.translated_from_with": "Käännetty kielestä {lang} palvelulla {provider}",
  "status.uncached_media_warning": "Esikatselu ei saatavilla",
  "status.unmute_conversation": "Kumoa keskustelun mykistys",
  "status.unpin": "Irrota profiilista",
  "subscribed_languages.lead": "Vain valituilla kielillä kirjoitetut julkaisut näkyvät koti- ja lista-aikajanoillasi muutoksen jälkeen. Älä valitse mitään, jos haluat nähdä julkaisuja kaikilla kielillä.",
  "subscribed_languages.save": "Tallenna muutokset",
  "subscribed_languages.target": "Vaihda tilattuja kieliä käyttäjältä {target}",
  "tabs_bar.home": "Koti",
  "tabs_bar.menu": "Valikko",
  "tabs_bar.notifications": "Ilmoitukset",
  "tabs_bar.publish": "Uusi julkaisu",
  "tabs_bar.quick_links": "Pikalinkit",
  "tabs_bar.search": "Haku",
  "tag.remove": "Poista",
  "terms_of_service.effective_as_of": "Tulee voimaan {date}",
  "terms_of_service.title": "Käyttöehdot",
  "terms_of_service.upcoming_changes_on": "Tulevia muutoksia {date}",
  "time_remaining.days": "{number, plural, one {# päivä} other {# päivää}} jäljellä",
  "time_remaining.hours": "{number, plural, one {# tunti} other {# tuntia}} jäljellä",
  "time_remaining.minutes": "{number, plural, one {# minuutti} other {# minuuttia}} jäljellä",
  "time_remaining.moments": "Hetkiä jäljellä",
  "time_remaining.seconds": "{number, plural, one {# sekunti} other {# sekuntia}} jäljellä",
  "trends.counter_by_accounts": "{count, plural, one {{counter} käyttäjä} other {{counter} käyttäjää}} {days, plural, one {viime päivänä} other {viimeisenä {days} päivänä}}",
  "trends.trending_now": "Suosittua nyt",
  "ui.beforeunload": "Luonnos häviää, jos poistut Mastodonista.",
  "units.short.billion": "{count} mrd.",
  "units.short.million": "{count} milj.",
  "units.short.thousand": "{count} t.",
  "upload_area.title": "Lähetä raahaamalla ja pudottamalla tähän",
  "upload_button.label": "Lisää kuvia, video tai äänitiedosto",
  "upload_error.limit": "Tiedostolähetysten rajoitus ylitetty.",
  "upload_error.poll": "Tiedostojen lisääminen äänestysten oheen ei ole sallittua.",
  "upload_error.quote": "Tiedostojen lähettäminen ei ole sallittua lainauksissa.",
  "upload_form.drag_and_drop.instructions": "Valitse medialiite painamalla välilyöntiä tai enteriä. Vetäessäsi käytä nuolinäppäimiä siirtääksesi medialiitettä vastaavaan suuntaan. Paina välilyöntiä tai enteriä uudelleen pudottaaksesi medialiitteen uuteen kohtaansa, tai peru siirto painamalla escape-näppäintä.",
  "upload_form.drag_and_drop.on_drag_cancel": "Veto peruttu. Medialiitettä {item} ei siirretty.",
  "upload_form.drag_and_drop.on_drag_end": "Medialiite {item} pudotettiin.",
  "upload_form.drag_and_drop.on_drag_over": "Medialiite {item} siirretty.",
  "upload_form.drag_and_drop.on_drag_start": "Valittiin medialiite {item}.",
  "upload_form.edit": "Muokkaa",
  "upload_progress.label": "Lähetetään…",
  "upload_progress.processing": "Käsitellään…",
  "username.taken": "Tämä käyttäjänimi on jo käytössä. Kokeile toista",
  "video.close": "Sulje video",
  "video.download": "Lataa tiedosto",
  "video.exit_fullscreen": "Poistu koko näytön tilasta",
  "video.expand": "Laajenna video",
  "video.fullscreen": "Koko näyttö",
  "video.hide": "Piilota video",
  "video.mute": "Mykistä",
  "video.pause": "Tauko",
  "video.play": "Toista",
  "video.skip_backward": "Siirry taaksepäin",
  "video.skip_forward": "Siirry eteenpäin",
  "video.unmute": "Kumoa mykistys",
  "video.volume_down": "Vähennä äänenvoimakkuutta",
  "video.volume_up": "Lisää äänenvoimakkuutta",
  "visibility_modal.button_title": "Aseta näkyvyys",
  "visibility_modal.direct_quote_warning.text": "Jos tallennat nykyiset asetukset, upotettu lainaus muunnetaan linkiksi.",
  "visibility_modal.direct_quote_warning.title": "Lainauksia ei voi upottaa yksityismainintoihin",
  "visibility_modal.header": "Näkyvyys ja vuorovaikutus",
  "visibility_modal.helper.direct_quoting": "Muut eivät voi lainata Mastodonissa kirjoitettuja yksityismainintoja.",
  "visibility_modal.helper.privacy_editing": "Näkyvyyttä ei voi muuttaa julkaisun jälkeen.",
  "visibility_modal.helper.privacy_private_self_quote": "Yksityisten julkaisujen itselainauksista ei voi tehdä julkisia.",
  "visibility_modal.helper.private_quoting": "Muut eivät voi lainata Mastodonissa kirjoitettuja, vain seuraajille tarkoitettuja julkaisuja.",
  "visibility_modal.helper.unlisted_quoting": "Kun ihmiset lainaavat sinua, myös heidän julkaisunsa piilotetaan suosittujen julkaisujen aikajanoilta.",
  "visibility_modal.instructions": "Määritä, kuka voi olla vuorovaikutuksessa tämän julkaisun kanssa. Voit soveltaa asetuksia kaikkiin tuleviin julkaisuihin siirtymällä kohtaan <link>Asetukset > Julkaisun oletukset</link>.",
  "visibility_modal.privacy_label": "Näkyvyys",
  "visibility_modal.quote_followers": "Vain seuraajat",
  "visibility_modal.quote_label": "Kuka voi lainata",
  "visibility_modal.quote_nobody": "Vain minä",
  "visibility_modal.quote_public": "Kuka tahansa",
  "visibility_modal.save": "Tallenna"
}
